//@ts-nocheck
import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Button,
  Input,
  Select,
  DatePicker,
  message,
  Spin,
  Tooltip,
} from "antd";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  SearchOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { RiDeleteBinLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import PageLogoutButton from "../../Components/PageLogoutButton";
import CommonHeader from "../../Components/commonHeader";
import QuoteIdQuickNav from "../../Components/QuoteIdQuickNav";
import { normalizeSortRules, sortRulesToQuery, type SortRule } from "../../utils/sortRules";
import {
  getOpenOrders,
  updateOpenOrder,
  createOpenOrder,
  deleteOpenOrder,
  getStatuses,
  createStatus,
  updateStatus,
  deleteStatus,
  getManufacturers,
  createManufacturer,
  updateManufacturer,
  deleteManufacturer,
  getVendors,
  createVendor,
  updateVendor,
  deleteVendor,
  bulkImportOpenOrders,
  getShipTos,
  createShipTo,
  updateShipTo,
  deleteShipTo,
  getCalTypes,
  createCalType,
  updateCalType,
  deleteCalType,
  createOrderTracking,
  getOtcReps,
  getOtcPmts,
  getLeadFromOptions,
} from "../../utils/API";
import { syncOpenOrderToOrderTracking } from "../../utils/openOrderTrackingSync";
import dayjs from "dayjs";

const OPEN_ORDER_EXPORT_COLUMNS = [
  // Header
  { label: "Quote ID", key: "quoteId" },
  { label: "Customer", key: "customer" },
  { label: "Cust PO", key: "custPo" },
  { label: "Priority", key: "priority" },
  { label: "Expedite", key: "expedite" },
  { label: "Status", key: "status" },
  { label: "Sub Status", key: "subStatus" },
  { label: "Stock", key: "stock" },
  { label: "PO Date", key: "poDate" },
  { label: "Date Created", key: "dateCreated" },
  { label: "Last Update", key: "lastUpdate" },
  { label: "Resolution", key: "resolution" },
  // Block 1
  { label: "Vendor 1", key: "vendor1" },
  { label: "PO Sent 1", key: "poSent1" },
  { label: "Payment Sent 1", key: "pmtSent1" },
  { label: "Date Shipped 1", key: "shipped1" },
  { label: "Tracking 1", key: "tracking1" },
  { label: "Ship To 1", key: "shipTo1" },
  { label: "Cal Type 1", key: "calType1" },
  { label: "Manu 1", key: "manu1" },
  { label: "Model 1", key: "model1" },
  { label: "QTY 1", key: "qty1" },
  { label: "Serial 1", key: "serial1" },
  { label: "Options 1", key: "options1" },
  { label: "Manu 2", key: "manu2" },
  { label: "Model 2", key: "model2" },
  { label: "QTY 2", key: "qty2" },
  { label: "Serial 2", key: "serial2" },
  { label: "Options 2", key: "options2" },
  { label: "Manu 3", key: "manu3" },
  { label: "Model 3", key: "model3" },
  { label: "QTY 3", key: "qty3" },
  { label: "Serial 3", key: "serial3" },
  { label: "Options 3", key: "options3" },
  { label: "Vendor Comments 1", key: "vendorComments1" },
  { label: "RMA Notes 1", key: "rmaNotes1" },
  { label: "General Comments 1", key: "generalComments1" },
  { label: "Cal Lab Comments 1", key: "calLabComments1" },
  // Block 2
  { label: "Vendor 2", key: "vendor2" },
  { label: "PO Sent 2", key: "poSent2" },
  { label: "Payment Sent 2", key: "pmtSent2" },
  { label: "Date Shipped 2", key: "shipped2" },
  { label: "Tracking 2", key: "tracking2" },
  { label: "Ship To 2", key: "shipTo2" },
  { label: "Cal Type 2", key: "calType2" },
  { label: "Manu 4", key: "manu4" },
  { label: "Model 4", key: "model4" },
  { label: "QTY 4", key: "qty4" },
  { label: "Serial 4", key: "serial4" },
  { label: "Options 4", key: "options4" },
  { label: "Manu 5", key: "manu5" },
  { label: "Model 5", key: "model5" },
  { label: "QTY 5", key: "qty5" },
  { label: "Serial 5", key: "serial5" },
  { label: "Options 5", key: "options5" },
  { label: "Manu 6", key: "manu6" },
  { label: "Model 6", key: "model6" },
  { label: "QTY 6", key: "qty6" },
  { label: "Serial 6", key: "serial6" },
  { label: "Options 6", key: "options6" },
  { label: "Vendor Comments 2", key: "vendorComments2" },
  { label: "RMA Notes 2", key: "rmaNotes2" },
  { label: "General Comments 2", key: "generalComments2" },
  { label: "Cal Lab Comments 2", key: "calLabComments2" },
  // Block 3
  { label: "Vendor 3", key: "vendor3" },
  { label: "PO Sent 3", key: "poSent3" },
  { label: "Payment Sent 3", key: "pmtSent3" },
  { label: "Date Shipped 3", key: "shipped3" },
  { label: "Tracking 3", key: "tracking3" },
  { label: "Ship To 3", key: "shipTo3" },
  { label: "Cal Type 3", key: "calType3" },
  { label: "Manu 7", key: "manu7" },
  { label: "Model 7", key: "model7" },
  { label: "QTY 7", key: "qty7" },
  { label: "Serial 7", key: "serial7" },
  { label: "Options 7", key: "options7" },
  { label: "Manu 8", key: "manu8" },
  { label: "Model 8", key: "model8" },
  { label: "QTY 8", key: "qty8" },
  { label: "Serial 8", key: "serial8" },
  { label: "Options 8", key: "options8" },
  { label: "Manu 9", key: "manu9" },
  { label: "Model 9", key: "model9" },
  { label: "QTY 9", key: "qty9" },
  { label: "Serial 9", key: "serial9" },
  { label: "Options 9", key: "options9" },
  { label: "Vendor Comments 3", key: "vendorComments3" },
  { label: "RMA Notes 3", key: "rmaNotes3" },
  { label: "General Comments 3", key: "generalComments3" },
  { label: "Cal Lab Comments 3", key: "calLabComments3" },
];

const OPEN_ORDER_SORT_KEYS = OPEN_ORDER_EXPORT_COLUMNS.map((column) => column.key);

const { TextArea } = Input;

// Types
interface OrderItem {
  model: string;
  qty: number;
  manu: string;
  serial: string;
  options: string;
}

interface OrderBlockData {
  vendor: string;
  poSent: string | null;
  pmtSent: string | null;
  items: OrderItem[];
  shipped: string | null;
  tracking: string;
  shipTo: string;
  calType: string;
  vendorComments: string;
  rmaNotes: string;
  generalComments: string;
  calLabComments: string;
}

interface OpenOrderData {
  id?: number;
  customer: string;
  custPo: string;
  expedite: string;
  priority: string;
  status: string;
  subStatus: string;
  stock: string;
  dateCreated: string | null;
  poDate: string | null;
  lastUpdate: string | null;
  resolution: string;
  quoteId: string;
  orderBlocks: OrderBlockData[];
}

interface Manufacturer {
  id: number;
  name: string;
}

interface Vendor {
  id: number;
  name: string;
}

type StatusOption = {
  id: number;
  value: string;
  label: string;
  type: string;
};

// --- Sub-Component: Individual Order Block ---

const OpenOrderBlock = ({
  data,
  blockIndex,
  onUpdate,
  manufacturers,
  onOpenManufacturerModal,
  vendors,
  onOpenVendorModal,
  shipTos,
  onOpenShipToModal,
  calTypes,
  onOpenCalTypeModal,
  isFindMode = false,
  findFields = {},
  onFindFieldChange,
  onPerformFind,
}: {
  data: OrderBlockData;
  blockIndex: number;
  onUpdate: (blockIndex: number, field: string, value: any, itemIndex?: number) => void;
  manufacturers: Manufacturer[];
  onOpenManufacturerModal: () => void;
  vendors: Vendor[];
  onOpenVendorModal: () => void;
  shipTos: { id: number; name: string }[];
  onOpenShipToModal: () => void;
  calTypes: { id: number; name: string }[];
  onOpenCalTypeModal: () => void;
  isFindMode?: boolean;
  findFields?: Record<string, string>;
  onFindFieldChange?: (field: string, value: string) => void;
  onPerformFind?: () => void;
}) => {
  const handleItemUpdate = (itemIndex: number, field: string, value: any) => {
    console.log(
      `Updating Block ${blockIndex}, Item ${itemIndex}, Field ${field}:`,
      value,
    );
    onUpdate(blockIndex, `items.${itemIndex}.${field}`, value, itemIndex);
  };

  const handleFieldUpdate = (field: string, value: any) => {
    console.log(`Updating Block ${blockIndex}, Field ${field}:`, value);
    onUpdate(blockIndex, field, value);
  };

  // Get manufacturer options with edit option at the end
  const manufacturerOptions = [
    ...manufacturers.map((m) => ({
      value: m.name,
      label: m.name,
    })),
    {
      value: "___EDIT_MANUFACTURERS___",
      label: "✎ Edit Manufacturers...",
      disabled: false,
    },
  ];

  // Handle manufacturer selection
  const handleManufacturerSelect = (value: string, itemIndex: number) => {
    if (value === "___EDIT_MANUFACTURERS___") {
      onOpenManufacturerModal();
    } else {
      handleItemUpdate(itemIndex, "manu", value);
    }
  };

  const vendorOptions = [
    ...vendors.map((vendor) => ({
      value: vendor.name,
      label: vendor.name,
    })),
    {
      value: "___EDIT_VENDORS___",
      label: "Edit Vendors...",
      disabled: false,
    },
  ];

  const handleVendorSelect = (value: string) => {
    if (value === "___EDIT_VENDORS___") {
      onOpenVendorModal();
      return;
    }
    handleFieldUpdate("vendor", value);
  };

  const isWhiteRow = blockIndex === 1;
  const rowBg = isWhiteRow ? "#FFFFFF" : "#CCFFCC";
  const vendorCommentsBg = isWhiteRow ? "#FFFFFF" : "#CCFFCC";
  const calLabBg = isWhiteRow ? "#FFFFFF" : "#CCFFCC";

  return (
    <div className="mb-2 overflow-hidden font-sans">
      <div
        className="flex"
        style={{
          borderTop: "1px solid #000000",
          paddingTop: "4px",
          marginTop: "2px",
        }}
      >
        {/* --- LEFT COLUMN: VENDOR & ITEMS --- */}
        <div className="flex-[10]" style={{ backgroundColor: rowBg, padding: "6px" }}>
          {/* Vendor Row */}
          <div className="flex items-center gap-2 mb-2">
            <label className="text-[11px] font-bold text-black whitespace-nowrap">
              Vendor
            </label>
            {isFindMode && blockIndex === 0 ? (
              <Select value={findFields.vendor || undefined} allowClear size="small" className="w-56 !text-xs" placeholder="Search vendor..." showSearch options={vendors.map((v) => ({ value: v.name, label: v.name }))} filterOption={(input, option) => (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())} onChange={(value) => onFindFieldChange?.("vendor", value || "")} />
            ) : (
              <Select value={isFindMode ? "" : data.vendor} onChange={(value) => handleVendorSelect(value ?? "")} allowClear size="small" className="w-56 !text-xs" options={isFindMode ? [] : vendorOptions} showSearch filterOption={(input, option) => option?.value === "___EDIT_VENDORS___" || (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())} disabled={isFindMode && blockIndex !== 0} />
            )}
            <div className="flex items-center gap-3 ml-2">
              <div className="flex items-center gap-1">
                <span className="text-[10px] text-black font-bold whitespace-nowrap">
                  PO Sent
                </span>
                <DatePicker
                  value={isFindMode ? (blockIndex === 0 && findFields.poSent ? dayjs(findFields.poSent) : null) : (data.poSent ? dayjs(data.poSent) : null)}
                  format="MM/DD/YYYY"
                  placeholder={isFindMode ? "Search" : undefined}
                  disabled={isFindMode && blockIndex !== 0}
                  onChange={(date) =>
                    isFindMode
                      ? onFindFieldChange?.("poSent", date?.format("YYYY-MM-DD") || "")
                      : handleFieldUpdate("poSent", date?.format("YYYY-MM-DD") || null)
                  }
                  className="h-[22px] w-auto text-[10px]"
                  size="small"
                />
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[10px] text-black font-bold whitespace-nowrap">
                  Pmt Sent
                </span>
                <DatePicker
                  value={isFindMode ? (blockIndex === 0 && findFields.pmtSent ? dayjs(findFields.pmtSent) : null) : (data.pmtSent ? dayjs(data.pmtSent) : null)}
                  format="MM/DD/YYYY"
                  placeholder={isFindMode ? "Search" : undefined}
                  disabled={isFindMode && blockIndex !== 0}
                  onChange={(date) =>
                    isFindMode
                      ? onFindFieldChange?.("pmtSent", date?.format("YYYY-MM-DD") || "")
                      : handleFieldUpdate("pmtSent", date?.format("YYYY-MM-DD") || null)
                  }
                  className="h-[22px] w-auto text-[10px]"
                  size="small"
                />
              </div>
            </div>
          </div>

          {/* Item Rows */}
          <div>
            {data.items.map((item, itemIdx) => (
              <div
                key={`block-${blockIndex}-item-${itemIdx}`}
                className="mb-2"
              >
                <div className="flex gap-2">
                  {/* Left: Model/QTY/Manu + Serial stacked */}
                  <div className="flex-1">
                    {/* Model / QTY / Manu row */}
                    <div className="flex items-center gap-2 mb-1">
                      <label className="text-[11px] font-bold text-black whitespace-nowrap w-10">Model</label>
                      {isFindMode && blockIndex === 0 && itemIdx === 0 ? (
                        <div style={{ position: "relative" }}>
                          <Input className="!h-[22px] text-xs w-24" value={findFields.model || ""} onChange={(e) => onFindFieldChange?.("model", e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onPerformFind?.(); } }} />
                          <SearchOutlined style={{ position: "absolute", right: 5, top: "50%", transform: "translateY(-50%)", color: "#888", fontSize: 11, pointerEvents: "none" }} />
                        </div>
                      ) : (
                        <Input className="!h-[22px] text-xs w-24" value={isFindMode ? "" : (item.model || "")} readOnly={isFindMode} onChange={(e) => handleItemUpdate(itemIdx, "model", e.target.value)} />
                      )}
                      <label className="text-[11px] font-bold text-black whitespace-nowrap">QTY</label>
                      {isFindMode && blockIndex === 0 && itemIdx === 0 ? (
                        <Input type="number" className="!h-[22px] text-xs w-16 text-center" value={findFields.qty || ""} onChange={(e) => onFindFieldChange?.("qty", e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onPerformFind?.(); } }} />
                      ) : (
                        <Input type="number" className="!h-[22px] text-xs w-16 text-center" value={isFindMode ? "" : (item.qty === 0 ? "" : item.qty)} readOnly={isFindMode} onChange={(e) => { const value = e.target.value; handleItemUpdate(itemIdx, "qty", value === "" ? 0 : Number(value)); }} />
                      )}
                      <label className="text-[11px] font-bold text-black whitespace-nowrap">Manu</label>
                      {isFindMode && blockIndex === 0 && itemIdx === 0 ? (
                        <Select value={findFields.manu || undefined} allowClear size="small" className="w-32 [&_.ant-select-selector]:!h-[22px] [&_.ant-select-selection-item]:!text-xs" placeholder="Search manu..." showSearch options={manufacturers.map((m) => ({ value: m.name, label: m.name }))} filterOption={(input, option) => (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())} onChange={(value) => onFindFieldChange?.("manu", value || "")} />
                      ) : (
                        <Select size="small" value={isFindMode ? "" : (item.manu || "")} onChange={(value) => handleManufacturerSelect(value ?? "", itemIdx)} allowClear className="w-32 [&_.ant-select-selector]:!h-[22px] [&_.ant-select-selection-item]:!text-xs" options={isFindMode ? [] : manufacturerOptions} showSearch filterOption={(input, option) => option?.value === "___EDIT_MANUFACTURERS___" || (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())} placeholder="Select" disabled={isFindMode && !(blockIndex === 0 && itemIdx === 0)} />
                      )}
                    </div>
                    {/* Serial Number row */}
                    <div className="flex items-center gap-2 pl-6">
                      <label className="text-[11px] font-bold text-black whitespace-nowrap">Serial Number</label>
                      {isFindMode && blockIndex === 0 && itemIdx === 0 ? (
                        <div style={{ position: "relative" }} className="w-32">
                          <Input className="!h-[22px] text-xs w-full" value={findFields.serialNumber || ""} onChange={(e) => onFindFieldChange?.("serialNumber", e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onPerformFind?.(); } }} />
                          <SearchOutlined style={{ position: "absolute", right: 5, top: "50%", transform: "translateY(-50%)", color: "#888", fontSize: 11, pointerEvents: "none" }} />
                        </div>
                      ) : (
                        <Input className="!h-[22px] text-xs w-32" value={isFindMode ? "" : (item.serial || "")} readOnly={isFindMode} onChange={(e) => handleItemUpdate(itemIdx, "serial", e.target.value)} />
                      )}
                    </div>
                  </div>
                  {/* Right: OPT textarea spanning both rows */}
                  <div className="flex items-start gap-1 flex-1">
                    <label className="text-[11px] font-bold text-black whitespace-nowrap mt-1">
                      OPT
                    </label>
                    {isFindMode && blockIndex === 0 && itemIdx === 0 ? (
                      <Input.TextArea
                        className="text-xs flex-1"
                        style={{ resize: "none", height: "48px", minHeight: "48px" }}
                        placeholder="Search..."
                        value={findFields.options || ""}
                        onChange={(e) => onFindFieldChange?.("options", e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPerformFind?.(); } }}
                      />
                    ) : (
                      <Input.TextArea
                        className="text-xs flex-1"
                        style={{ resize: "none", height: "48px", minHeight: "48px" }}
                        value={isFindMode ? "" : (item.options || "")}
                        readOnly={isFindMode}
                        onChange={(e) =>
                          handleItemUpdate(itemIdx, "options", e.target.value)
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Shipping Info */}
          <div className="mt-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-[11px] font-bold text-black whitespace-nowrap">
                Vendor Shipped
              </span>
              <DatePicker
                size="small"
                className="w-28 text-[10px] !h-[22px]"
                format="MM/DD/YYYY"
                placeholder={isFindMode ? "Search" : undefined}
                disabled={isFindMode && blockIndex !== 0}
                value={isFindMode ? (blockIndex === 0 && findFields.shipped ? dayjs(findFields.shipped) : null) : (data.shipped ? dayjs(data.shipped) : null)}
                onChange={(date) =>
                  isFindMode
                    ? onFindFieldChange?.("shipped", date?.format("YYYY-MM-DD") || "")
                    : handleFieldUpdate("shipped", date?.format("YYYY-MM-DD") || null)
                }
              />
              <span className="text-[11px] font-bold text-black whitespace-nowrap ml-1">
                Tracking Number
              </span>
              <Input
                className="!h-[22px] text-xs flex-1"
                placeholder={isFindMode && blockIndex === 0 ? "Search..." : undefined}
                value={isFindMode ? (blockIndex === 0 ? (findFields.tracking || "") : "") : (data.tracking || "")}
                readOnly={isFindMode && blockIndex !== 0}
                onChange={(e) =>
                  isFindMode
                    ? onFindFieldChange?.("tracking", e.target.value)
                    : handleFieldUpdate("tracking", e.target.value)
                }
                onKeyDown={isFindMode ? (e) => { if (e.key === "Enter") { e.preventDefault(); onPerformFind?.(); } } : undefined}
              />
            </div>
            <div className="flex items-center gap-2 mb-1">
              <span className="text-[11px] font-bold text-black whitespace-nowrap">
                Vendor Ship To
              </span>
              {isFindMode ? (
                <Select
                  size="small"
                  className="w-40 text-xs"
                  popupMatchSelectWidth={false}
                  allowClear
                  showSearch
                  placeholder={blockIndex === 0 ? "Search..." : ""}
                  disabled={blockIndex !== 0}
                  value={blockIndex === 0 ? (findFields.shipTo || undefined) : undefined}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())}
                  onChange={(value) => onFindFieldChange?.("shipTo", value || "")}
                  options={shipTos.map((s) => ({ value: s.name, label: s.name }))}
                />
              ) : (
                <Select
                  size="small"
                  className="w-40 text-xs"
                  popupMatchSelectWidth={false}
                  value={data.shipTo || undefined}
                  allowClear
                  placeholder=""
                  onChange={(value) => {
                    if (value === "___EDIT_SHIP_TO___") { onOpenShipToModal(); return; }
                    handleFieldUpdate("shipTo", value ?? "");
                  }}
                  options={[
                    ...shipTos.map((s) => ({ value: s.name, label: s.name })),
                    { value: "___EDIT_SHIP_TO___", label: "✎ Edit Ship To..." },
                  ]}
                />
              )}
              <span className="text-[11px] font-bold text-black whitespace-nowrap ml-1">
                Cal Type Required
              </span>
              {isFindMode ? (
                <Select
                  size="small"
                  className="w-32 text-xs"
                  allowClear
                  showSearch
                  placeholder={blockIndex === 0 ? "Search..." : ""}
                  disabled={blockIndex !== 0}
                  value={blockIndex === 0 ? (findFields.calType || undefined) : undefined}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())}
                  onChange={(value) => onFindFieldChange?.("calType", value || "")}
                  options={calTypes.map((c) => ({ value: c.name, label: c.name }))}
                />
              ) : (
                <Select
                  size="small"
                  className="w-32 text-xs"
                  value={data.calType || undefined}
                  allowClear
                  placeholder=""
                  onChange={(value) => {
                    if (value === "___EDIT_CAL_TYPE___") { onOpenCalTypeModal(); return; }
                    handleFieldUpdate("calType", value ?? "");
                  }}
                  options={[
                    ...calTypes.map((c) => ({ value: c.name, label: c.name })),
                    { value: "___EDIT_CAL_TYPE___", label: "✎ Edit Cal Types..." },
                  ]}
                />
              )}
            </div>
          </div>

          {/* Vendor Comments */}
          <div className="mt-1">
            <div className="flex items-start gap-2">
              <label className="text-[11px] font-bold text-black whitespace-nowrap mt-1">
                Vendor Comments
              </label>
              <Input.TextArea
                rows={2}
                className="text-xs flex-1"
                style={{
                  resize: "none",
                  backgroundColor: vendorCommentsBg,
                  border: "1px solid #2563eb",
                  borderRadius: "0",
                }}
                placeholder={isFindMode && blockIndex === 0 ? "Search..." : undefined}
                readOnly={isFindMode && blockIndex !== 0}
                value={isFindMode ? (blockIndex === 0 ? (findFields.vendorComments || "") : "") : (data.vendorComments || "")}
                onChange={(e) =>
                  isFindMode
                    ? onFindFieldChange?.("vendorComments", e.target.value)
                    : handleFieldUpdate("vendorComments", e.target.value)
                }
                onKeyDown={isFindMode ? (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPerformFind?.(); } } : undefined}
              />
            </div>
          </div>
        </div>

        {/* --- RIGHT SIDE: RMA + Cal Lab on top, General Comments spanning below --- */}
        <div className="flex-[14] flex flex-col" style={{ backgroundColor: rowBg }}>
          {/* TOP ROW: RMA Notes (left) + Cal Lab/Test Comments (right) */}
          <div className="flex flex-1">
            {/* RMA Notes */}
            <div className="flex-1 flex flex-col" style={{ padding: "6px" }}>
              <label className="text-[11px] font-bold text-black mb-1 block">
                RMA Notes
              </label>
              <Input.TextArea
                className="p-1 text-xs flex-1"
                style={{
                  resize: "none",
                  backgroundColor: "#CCFFFF",
                  minHeight: "120px",
                  borderRadius: "0",
                }}
                placeholder={isFindMode && blockIndex === 0 ? "Search..." : undefined}
                readOnly={isFindMode && blockIndex !== 0}
                value={isFindMode ? (blockIndex === 0 ? (findFields.rmaNotes || "") : "") : (data.rmaNotes || "")}
                onChange={(e) =>
                  isFindMode
                    ? onFindFieldChange?.("rmaNotes", e.target.value)
                    : handleFieldUpdate("rmaNotes", e.target.value)
                }
                onKeyDown={isFindMode ? (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPerformFind?.(); } } : undefined}
              />
            </div>
            {/* Cal Lab / Test Comments */}
            <div className="flex-1 flex flex-col" style={{ padding: "6px" }}>
              <div className="flex justify-between items-center mb-1">
                <label className="text-[11px] font-bold text-black">
                  Cal Lab/Test Comments
                </label>
                <span className="text-[11px] font-bold text-black">Admin Instructions to Task</span>
              </div>
              <Input.TextArea
                className="p-1 flex-1"
                style={{
                  resize: "none",
                  backgroundColor: calLabBg,
                  border: "1px solid #2563eb",
                  borderRadius: "0",
                  minHeight: "120px",
                }}
                placeholder={isFindMode && blockIndex === 0 ? "Search..." : undefined}
                readOnly={isFindMode && blockIndex !== 0}
                value={isFindMode ? (blockIndex === 0 ? (findFields.calLabComments || "") : "") : (data.calLabComments || "")}
                onChange={(e) =>
                  isFindMode
                    ? onFindFieldChange?.("calLabComments", e.target.value)
                    : handleFieldUpdate("calLabComments", e.target.value)
                }
                onKeyDown={isFindMode ? (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPerformFind?.(); } } : undefined}
              />
            </div>
          </div>
          {/* BOTTOM ROW: General Order Comments (full width) */}
          <div
            className="flex flex-col"
            style={{
              padding: "6px",
              paddingTop: "4px",
            }}
          >
            <div className="flex justify-between items-center mb-1">
              <label className="text-[11px] font-bold text-black">
                General Order Comments
              </label>
              <span className="text-[11px] font-bold text-black">Admin Results</span>
            </div>
            <Input.TextArea
              className="p-1 text-[11px]"
              style={{
                resize: "none",
                backgroundColor: "#FFFFFF",
                color: "#000000",
                minHeight: "120px",
                border: "1px solid #2563eb",
                borderRadius: "0",
              }}
              placeholder={isFindMode && blockIndex === 0 ? "Search..." : undefined}
              readOnly={isFindMode && blockIndex !== 0}
              value={isFindMode ? (blockIndex === 0 ? (findFields.generalComments || "") : "") : (data.generalComments || "")}
              onChange={(e) =>
                isFindMode
                  ? onFindFieldChange?.("generalComments", e.target.value)
                  : handleFieldUpdate("generalComments", e.target.value)
              }
              onKeyDown={isFindMode ? (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPerformFind?.(); } } : undefined}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const extractRows = (response: any): any[] => {
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.rows)) return response.rows;
  if (Array.isArray(response?.records)) return response.records;
  return [];
};

// --- Send to Order Tracking Modal ---
// Visually replicates Order Tracking's record editor layout (header row,
// 5 item rows, RMA, comments, invoice/footer columns) so it looks the same
// as the real page. Only the 8 fields listed by the OOR->OTC feature request
// (quote id, customer, manu/model/qty/serial x5, vendor/tracking x3) are
// prefilled from the Open Order record and actually sent on save — every
// other field is shown for visual completeness/editability only.
const SendToOrderTrackingModal = ({
  draft,
  setDraft,
  saving,
  manufacturers,
  vendors,
  onCancel,
  onSave,
}: {
  draft: any;
  setDraft: (updater: (prev: any) => any) => void;
  saving: boolean;
  manufacturers: { id: number; name: string }[];
  vendors: { id: number; name: string }[];
  onCancel: () => void;
  onSave: () => void;
}) => {
  const [otcReps, setOtcReps] = useState<{ id: number; name: string }[]>([]);
  const [otcPmts, setOtcPmts] = useState<{ id: number; name: string }[]>([]);
  const [leadFromOptions, setLeadFromOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [poStatusOptions, setPoStatusOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [actionOptions, setActionOptions] = useState<
    { value: string; label: string }[]
  >([]);

  useEffect(() => {
    (async () => {
      try {
        const reps = await getOtcReps();
        setOtcReps(Array.isArray(reps) ? reps : []);
      } catch {
        setOtcReps([]);
      }
      try {
        const pmts = await getOtcPmts();
        setOtcPmts(Array.isArray(pmts) ? pmts : []);
      } catch {
        setOtcPmts([]);
      }
      try {
        const sources = await getLeadFromOptions();
        setLeadFromOptions(
          Array.isArray(sources)
            ? sources.map((s: any) => ({ value: s.name, label: s.name }))
            : [],
        );
      } catch {
        setLeadFromOptions([]);
      }
      try {
        const statuses = await getStatuses();
        const list = Array.isArray(statuses) ? statuses : [];
        setPoStatusOptions(
          list
            .filter((s: any) => s.type === "order_tracking")
            .map((s: any) => ({ value: s.statusName, label: s.statusName })),
        );
        setActionOptions(
          list
            .filter((s: any) => s.type === "otc-actions")
            .map((s: any) => ({ value: s.statusName, label: s.statusName })),
        );
      } catch {
        setPoStatusOptions([]);
        setActionOptions([]);
      }
    })();
  }, []);

  const otInputStyle: React.CSSProperties = {
    height: 28,
    fontSize: 12,
    borderRadius: 2,
    border: "1px solid #292929",
  };
  const otLabelCls = "text-[11px] font-bold text-black mb-1";
  const setField = (field: string, value: any) =>
    setDraft((prev: any) => ({ ...prev, [field]: value }));

  const slots = [
    { manu: "manu", model: "model", qty: "qty", sn: "sn", vendor: "vendor", tracking: "trackingNo" },
    { manu: "manu2", model: "model2", qty: "qty2", sn: "sn2", vendor: "vendor2", tracking: "trackingNo2" },
    { manu: "manu3", model: "model3", qty: "qty3", sn: "sn3", vendor: "vendor3", tracking: "trackingNo3" },
    { manu: "manu4", model: "model4", qty: "qty4", sn: "sn4", vendor: "", tracking: "trackingNo4" },
    { manu: "manu5", model: "model5", qty: "qty5", sn: "sn5", vendor: "", tracking: "trackingNo5" },
  ];

  const dateValue = (v: any) => (v ? dayjs(v) : null);

  return (
    <>
      <div
        className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
        onClick={onCancel}
      />
      <div className="fixed inset-0 z-50 flex items-start justify-center pt-8 overflow-y-auto pb-8">
        <div
          className="relative rounded-lg shadow-xl border border-gray-300 max-w-[98vw] overflow-x-auto"
          style={{ backgroundColor: "#CCFFCC", width: 1240 }}
        >
          <div className="p-3 border-b border-gray-300 flex justify-between items-center bg-gray-50 rounded-t-lg">
            <h3 className="text-[14px] font-semibold text-gray-700">
              Send to Order Tracking
            </h3>
            <Button
              type="text"
              size="small"
              className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
              onClick={onCancel}
            >
              ✕
            </Button>
          </div>

          <div className="p-4">
            <section
              className="grid gap-x-3"
              style={{ gridTemplateColumns: "680px 200px 260px", alignItems: "start" }}
            >
              {/* ===== LEFT: header row + 5 item rows + RMA ===== */}
              <article>
                <section
                  className="grid gap-x-1 gap-y-1 mb-2"
                  style={{ gridTemplateColumns: "75px 85px 80px 140px 100px 80px 90px" }}
                >
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Rep</span>
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={draft.rep || undefined}
                      placeholder="Select Rep"
                      showSearch
                      allowClear
                      options={otcReps.map((r) => ({ value: r.name, label: r.name }))}
                      onChange={(value) => setField("rep", value || "")}
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>PO Date</span>
                    <DatePicker
                      className="w-full"
                      format="MM/DD/YYYY"
                      style={{ height: 28, fontSize: 10 }}
                      suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                      value={dateValue(draft.poDate)}
                      onChange={(date) => setField("poDate", date ? date.format("YYYY-MM-DD") : "")}
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Cust PO #</span>
                    <Input
                      value={draft.custPo || ""}
                      style={{ ...otInputStyle, color: "blue" }}
                      onChange={(e) => setField("custPo", e.target.value)}
                      placeholder="Enter Cust PO #"
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Customer</span>
                    <Input
                      value={draft.customer || ""}
                      style={{ ...otInputStyle, backgroundColor: "#c0c0c0", fontWeight: "bold", color: "blue" }}
                      onChange={(e) => setField("customer", e.target.value)}
                      placeholder="Enter Customer"
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Gross Sale</span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        ...otInputStyle,
                        paddingLeft: 6,
                        paddingRight: 4,
                        boxSizing: "border-box",
                        backgroundColor: "#fff",
                      }}
                    >
                      <span style={{ fontSize: 12, color: "#000", flexShrink: 0, lineHeight: 1, userSelect: "none" }}>
                        $
                      </span>
                      <input
                        value={draft.gs || ""}
                        onChange={(e) => setField("gs", e.target.value)}
                        placeholder="0.00"
                        style={{ flex: 1, border: "none", outline: "none", background: "transparent", fontSize: 12, minWidth: 0, padding: "0 4px", color: "#000" }}
                      />
                    </div>
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Gross Margin</span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        ...otInputStyle,
                        backgroundColor: "#c0c0c0",
                        paddingLeft: 6,
                        paddingRight: 4,
                        boxSizing: "border-box",
                      }}
                    >
                      <span style={{ fontSize: 12, color: "#000", flexShrink: 0, lineHeight: 1, userSelect: "none" }}>
                        $
                      </span>
                      <input
                        value={draft.gm || ""}
                        onChange={(e) => setField("gm", e.target.value)}
                        placeholder="0.00"
                        style={{ flex: 1, border: "none", outline: "none", background: "transparent", fontSize: 12, minWidth: 0, padding: "0 4px", color: "#000" }}
                      />
                    </div>
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Pmt</span>
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={draft.pmt || undefined}
                      placeholder="Select Pmt"
                      showSearch
                      allowClear
                      options={otcPmts.map((p) => ({ value: p.name, label: p.name }))}
                      onChange={(value) => setField("pmt", value || "")}
                    />
                  </section>
                </section>

                <section className="grid gap-x-6 mb-3" style={{ gridTemplateColumns: "160px 220px 160px" }}>
                  <section className="flex items-center gap-2">
                    <span className="text-[11px] font-bold text-black" style={{ width: 45 }}>Rental?</span>
                    <Input
                      value={draft.rental || ""}
                      style={{ ...otInputStyle, width: 100 }}
                      onChange={(e) => setField("rental", e.target.value)}
                    />
                  </section>
                  <section className="flex items-center gap-2">
                    <span className="text-[11px] font-bold text-black" style={{ width: 90 }}>Vendor RMA</span>
                    <Input
                      value={draft.vendorRma || ""}
                      style={{ ...otInputStyle, width: 140 }}
                      onChange={(e) => setField("vendorRma", e.target.value)}
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>PO Status</span>
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={draft.poStatus || undefined}
                      placeholder="Select Status"
                      allowClear
                      options={poStatusOptions}
                      onChange={(value) => setField("poStatus", value || "")}
                    />
                  </section>
                </section>

                {/* 5 item rows */}
                <section className="space-y-2">
                  {slots.map((slot, idx) => (
                    <section key={idx} className="space-y-1 pb-1 border-b border-dashed border-gray-400 last:border-b-0">
                      <section
                        className="grid gap-x-2"
                        style={{ gridTemplateColumns: idx < 2 ? "100px 110px 50px 205px 145px" : "100px 110px 50px 205px" }}
                      >
                        <section className="flex flex-col">
                          <span className={otLabelCls}>Manu</span>
                          <Select
                            showSearch
                            allowClear
                            size="small"
                            value={draft[slot.manu] || undefined}
                            style={otInputStyle}
                            options={manufacturers.map((m: any) => ({ value: m.name, label: m.name }))}
                            onChange={(value) => setField(slot.manu, value || "")}
                            filterOption={(input, option) =>
                              String(option?.label || "").toLowerCase().startsWith(input.toLowerCase())
                            }
                            placeholder="Select Manu..."
                          />
                        </section>
                        <section className="flex flex-col">
                          <span className={otLabelCls}>Model</span>
                          <Input
                            value={draft[slot.model] || ""}
                            style={otInputStyle}
                            onChange={(e) => setField(slot.model, e.target.value)}
                            placeholder="Enter Model"
                          />
                        </section>
                        <section className="flex flex-col">
                          <span className={otLabelCls}>Qty</span>
                          <Input
                            value={draft[slot.qty] || ""}
                            style={otInputStyle}
                            onChange={(e) => setField(slot.qty, e.target.value)}
                            placeholder="Qty"
                          />
                        </section>
                        <section className="flex flex-col">
                          <span className={otLabelCls}>Vendor</span>
                          {slot.vendor ? (
                            <Select
                              showSearch
                              allowClear
                              size="small"
                              value={draft[slot.vendor] || undefined}
                              style={otInputStyle}
                              options={vendors.map((v: any) => ({ value: v.name, label: v.name }))}
                              onChange={(value) => setField(slot.vendor, value || "")}
                              filterOption={(input, option) =>
                                String(option?.label || "").toLowerCase().startsWith(input.toLowerCase())
                              }
                              placeholder="Select Vendor..."
                            />
                          ) : (
                            <Input style={{ ...otInputStyle, backgroundColor: "#eeeeee" }} readOnly placeholder="—" />
                          )}
                        </section>
                        {idx < 2 && (
                          <section className="flex flex-col">
                            <span className={otLabelCls}>Ship to Cust..</span>
                            <DatePicker
                              className="w-full"
                              style={{ height: 28, fontSize: 12 }}
                              suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                              value={dateValue(draft[idx === 0 ? "dateShipped" : "dateShipped2"])}
                              onChange={(date) =>
                                setField(
                                  idx === 0 ? "dateShipped" : "dateShipped2",
                                  date ? date.format("YYYY-MM-DD") : "",
                                )
                              }
                            />
                          </section>
                        )}
                      </section>
                      <section className="grid items-center gap-x-2" style={{ gridTemplateColumns: "1fr 1fr" }}>
                        <section className="flex flex-col">
                          <span className={otLabelCls}>SN</span>
                          <Input
                            value={draft[slot.sn] || ""}
                            style={otInputStyle}
                            onChange={(e) => setField(slot.sn, e.target.value)}
                            placeholder="Enter SN"
                          />
                        </section>
                        <section className="flex flex-col">
                          <span className={otLabelCls}>Tracking #</span>
                          <Input
                            value={draft[slot.tracking] || ""}
                            style={otInputStyle}
                            onChange={(e) => setField(slot.tracking, e.target.value)}
                            placeholder="Enter Tracking #"
                          />
                        </section>
                      </section>
                    </section>
                  ))}
                </section>

                <section className="grid gap-x-2 mt-2" style={{ gridTemplateColumns: "1fr 1fr" }}>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>RMA</span>
                    <Input
                      value={draft.rma || ""}
                      style={otInputStyle}
                      onChange={(e) => setField("rma", e.target.value)}
                      placeholder="Enter RMA"
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>RMA Comment</span>
                    <Input.TextArea
                      style={{ fontSize: 12, borderRadius: 2, border: "1px solid #292929", resize: "none" }}
                      value={draft.rmaComment || ""}
                      onChange={(e) => setField("rmaComment", e.target.value)}
                      placeholder="Enter RMA Comment"
                    />
                  </section>
                </section>
              </article>

              {/* ===== COMMENTS ===== */}
              <aside>
                <span className={otLabelCls}>Comments</span>
                <Input.TextArea
                  value={draft.comments || ""}
                  style={{ fontSize: 12, borderRadius: 2, resize: "none", height: 400 }}
                  onChange={(e) => setField("comments", e.target.value)}
                  placeholder="Enter Comments"
                />
              </aside>

              {/* ===== RIGHT: invoice / footer fields ===== */}
              <aside>
                <section className="grid gap-x-2 gap-y-2" style={{ gridTemplateColumns: "1fr 1fr" }}>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Invoice Date</span>
                    <DatePicker
                      className="w-full"
                      format="MM/DD/YYYY"
                      style={{ height: 28, fontSize: 10 }}
                      suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                      value={dateValue(draft.invoiceDate)}
                      onChange={(date) => setField("invoiceDate", date ? date.format("YYYY-MM-DD") : "")}
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Invoice Number</span>
                    <Input
                      style={otInputStyle}
                      value={draft.ateInvoiceNo || ""}
                      onChange={(e) => setField("ateInvoiceNo", e.target.value)}
                      placeholder="Enter Invoice Number"
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={`${otLabelCls} whitespace-nowrap`}>Invoice Due Date</span>
                    <DatePicker
                      className="w-full"
                      format="MM/DD/YYYY"
                      style={{ height: 28, fontSize: 10 }}
                      suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                      value={dateValue(draft.invoiceDueDate)}
                      onChange={(date) => setField("invoiceDueDate", date ? date.format("YYYY-MM-DD") : "")}
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Invoice Total</span>
                    <Input
                      prefix={<span style={{ color: "red", fontWeight: "bold" }}>$</span>}
                      style={{ ...otInputStyle, color: "red", fontWeight: "bold" }}
                      value={draft.invoiceTotal || ""}
                      onChange={(e) => setField("invoiceTotal", e.target.value)}
                      placeholder="0.00"
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className={otLabelCls}>Paid?</span>
                    <Input
                      style={{ ...otInputStyle, color: "#dc2626", fontWeight: "bold" }}
                      value={draft.paid || ""}
                      onChange={(e) => setField("paid", e.target.value)}
                      placeholder="Yes/No"
                    />
                  </section>
                  <section className="flex flex-col">
                    <span className="text-[11px] font-bold mb-1">Vendor Paid?</span>
                    <DatePicker
                      className="w-full"
                      style={{ height: 28, fontSize: 8 }}
                      suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                      value={dateValue(draft.vendorPaid)}
                      onChange={(date) => setField("vendorPaid", date ? date.format("YYYY-MM-DD") : "")}
                    />
                  </section>

                  <section className="col-span-2">
                    <div className="grid gap-2" style={{ gridTemplateColumns: "60% 40%" }}>
                      <section className="flex flex-col">
                        <span className={otLabelCls}>Actions</span>
                        <Select
                          className="w-full"
                          size="small"
                          style={{ minHeight: 28 }}
                          allowClear
                          showSearch
                          placeholder="Select Action"
                          value={draft.actions || undefined}
                          options={actionOptions}
                          onChange={(value) => setField("actions", value || "")}
                          filterOption={(input, option) =>
                            String(option?.label || "").toLowerCase().startsWith(input.toLowerCase())
                          }
                        />
                      </section>
                      <section className="flex flex-col">
                        <span className={otLabelCls}>Order Complete</span>
                        <Select
                          size="small"
                          value={draft.orderComplete || undefined}
                          placeholder="Select Status"
                          onChange={(value) => setField("orderComplete", value)}
                          style={{ width: "100%" }}
                          options={[
                            { value: "Active order", label: "Active order" },
                            { value: "Closed", label: "Closed" },
                          ]}
                        />
                      </section>
                      <section className="col-span-2 mt-2">
                        <div className="grid items-center gap-2" style={{ gridTemplateColumns: "60px 1fr", columnGap: 6 }}>
                          <span className={otLabelCls}>Lead From</span>
                          <Select
                            className="w-full"
                            size="small"
                            options={leadFromOptions}
                            style={{ height: 28 }}
                            placeholder="Select Source"
                            value={draft.leadFrom || undefined}
                            onChange={(value) => setField("leadFrom", value)}
                          />
                        </div>
                      </section>
                    </div>
                  </section>
                </section>
              </aside>
            </section>

            {/* Quote ID / Sales Order footer row */}
            <footer className="flex items-center gap-4 mt-2 pt-2 border-t-2 border-black">
              <section className="flex items-center gap-2">
                <span className="text-[11px] font-bold text-black">Quote ID</span>
                <Input
                  value={draft.quoteId || ""}
                  style={{ ...otInputStyle, width: 113, height: 31 }}
                  onChange={(e) => setField("quoteId", e.target.value)}
                  placeholder="Enter Quote ID"
                />
              </section>
              <section className="flex items-center gap-2">
                <span className="text-[11px] font-bold text-black">Sales Order #</span>
                <Input
                  value={draft.salesOrder || ""}
                  style={{ ...otInputStyle, width: 120 }}
                  onChange={(e) => setField("salesOrder", e.target.value)}
                  placeholder="Enter Sales Order #"
                />
              </section>
            </footer>

            <div className="flex justify-end gap-3 mt-3 pt-3 border-t border-gray-300">
              <Button className="!border-black !text-black" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                type="primary"
                className="bg-[#004aad]"
                loading={saving}
                onClick={onSave}
              >
                Add
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// --- MAIN PAGE COMPONENT ---

const OpenOrder = () => {
  const STATUS_TYPE_OPEN_ORDER = "open_order";
  const STATUS_TYPE_OPEN_ORDER_PRIORITY = "openorder_priority";
  const STATUS_TYPE_OPEN_ORDER_STOCK = "openorder_stock";
  const STATUS_TYPE_OPEN_ORDER_SUB_STATUS = "openorder_ss";
  const STATUS_TYPE_OPEN_ORDER_RESOLUTION = "openorder_resolution";
  const navigate = useNavigate();
  const location = useLocation();
  const OO_STATE_KEY = "openOrderState";
  const _ooSaved = (() => { try { return JSON.parse(localStorage.getItem(OO_STATE_KEY) || "null") || {}; } catch { return {}; } })();
  const [sortRules, setSortRules] = useState<SortRule[]>(() => normalizeSortRules(_ooSaved.sortRules, OPEN_ORDER_SORT_KEYS));
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(_ooSaved.currentPage || 0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [unfilteredTotal, setUnfilteredTotal] = useState(_ooSaved.unfilteredTotal || 0);
  const buildSortParams = (rules = sortRules) => {
    const sort = sortRulesToQuery(rules, OPEN_ORDER_SORT_KEYS);
    return sort ? { sort } : {};
  };
  const [recordInputValue, setRecordInputValue] = useState("");
  const [isFindMode, setIsFindMode] = useState(_ooSaved.isFindMode || false);
  const [findFields, setFindFields] = useState(_ooSaved.findFields || { customer: "", custPo: "", quoteId: "", status: "", subStatus: "", priority: "", resolution: "", manu: "", model: "", vendor: "", serialNumber: "", expedite: "", stock: "", options: "", tracking: "", shipTo: "", calType: "", vendorComments: "", rmaNotes: "", calLabComments: "", generalComments: "", qty: "", poDate: "", poSent: "", pmtSent: "", shipped: "" });
  const [activeStatusFilter, setActiveStatusFilter] = useState<string | null>(
    _ooSaved.activeStatusFilter || null,
  );
  const [activeTodayFilter, setActiveTodayFilter] = useState(_ooSaved.activeTodayFilter || false);
  const [activeRmaFilter, setActiveRmaFilter] = useState(_ooSaved.activeRmaFilter || false);
  const [filteredRecords, setFilteredRecords] = useState<any[] | null>(null);
  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
  const [priorityOptions, setPriorityOptions] = useState<StatusOption[]>([]);
  const [stockOptions, setStockOptions] = useState<StatusOption[]>([]);
  const [subStatusOptions, setSubStatusOptions] = useState<StatusOption[]>([]);
  const [resolutionOptions, setResolutionOptions] = useState<StatusOption[]>(
    [],
  );
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [editingStatus, setEditingStatus] = useState({ index: -1, value: "" });
  const [newStatus, setNewStatus] = useState("");
  const [statusModalType, setStatusModalType] = useState<
    "status" | "priority" | "stock" | "subStatus" | "resolution"
  >("status");
  const [currentOrder, setCurrentOrder] = useState<OpenOrderData>({
    customer: "",
    custPo: "",
    expedite: "",
    priority: "",
    status: "",
    subStatus: "",
    stock: "",
    dateCreated: null,
    poDate: null,
    lastUpdate: null,
    resolution: "",
    quoteId: "",
    orderBlocks: [],
  });

  // Manufacturer state
  const [manufacturers, setManufacturers] = useState<Manufacturer[]>([]);
  const [isManufacturerModalOpen, setIsManufacturerModalOpen] = useState(false);
  const [editingManufacturer, setEditingManufacturer] =
    useState<Manufacturer | null>(null);
  const [newManufacturerName, setNewManufacturerName] = useState("");
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [vendorsLoading, setVendorsLoading] = useState(false);
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [editingVendor, setEditingVendor] = useState<Vendor | null>(null);
  const [newVendorName, setNewVendorName] = useState("");
  const [shipTos, setShipTos] = useState<{ id: number; name: string }[]>([]);
  const [isShipToModalOpen, setIsShipToModalOpen] = useState(false);
  const [editingShipTo, setEditingShipTo] = useState<{ id: number; name: string } | null>(null);
  const [newShipToName, setNewShipToName] = useState("");
  const [calTypes, setCalTypes] = useState<{ id: number; name: string }[]>([]);
  const [isCalTypeModalOpen, setIsCalTypeModalOpen] = useState(false);
  const [editingCalType, setEditingCalType] = useState<{ id: number; name: string } | null>(null);
  const [newCalTypeName, setNewCalTypeName] = useState("");

  // Send to Order Tracking modal state
  const [isSendToOrderTrackingOpen, setIsSendToOrderTrackingOpen] = useState(false);
  const [sendToOrderTrackingDraft, setSendToOrderTrackingDraft] = useState<any>(null);
  const [sendToOrderTrackingSaving, setSendToOrderTrackingSaving] = useState(false);

  const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Blocks whose tracking number changed since the last save — drained by
  // performSave to push those numbers into Order Tracking.
  const pendingTrackingSyncRef = useRef<Set<number>>(new Set());
  // Set when the Customer PO changed, so performSave mirrors it onto the
  // quote's Order Tracking rows (Cust PO # there).
  const pendingCustPoSyncRef = useRef(false);
  // Line items ("block:item") whose serial changed, mirrored into the
  // model-matched SN slot on the quote's Order Tracking rows.
  const pendingSerialSyncRef = useRef<Set<string>>(new Set());
  const preFilterPageRef = useRef<number>(0);
  const [manufacturersLoading, setManufacturersLoading] = useState(false);

  const refreshOpenOrderStatuses = useCallback(async () => {
    try {
      const statusResponse = await getStatuses();
      if (Array.isArray(statusResponse) && statusResponse.length > 0) {
        const mappedStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_OPEN_ORDER)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        const mappedStockStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_OPEN_ORDER_STOCK)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        const mappedPriorityStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_OPEN_ORDER_PRIORITY)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        const mappedSubStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_OPEN_ORDER_SUB_STATUS)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        const mappedResolutionStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_OPEN_ORDER_RESOLUTION)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        setStatusOptions(mappedStatuses);
        setPriorityOptions(mappedPriorityStatuses);
        setStockOptions(mappedStockStatuses);
        setSubStatusOptions(mappedSubStatuses);
        setResolutionOptions(mappedResolutionStatuses);
      } else {
        setStatusOptions([]);
        setPriorityOptions([]);
        setStockOptions([]);
        setSubStatusOptions([]);
        setResolutionOptions([]);
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load statuses",
      );
    }
  }, []);

  const getModalTypeKey = () => {
    if (statusModalType === "priority") return STATUS_TYPE_OPEN_ORDER_PRIORITY;
    if (statusModalType === "stock") return STATUS_TYPE_OPEN_ORDER_STOCK;
    if (statusModalType === "subStatus") return STATUS_TYPE_OPEN_ORDER_SUB_STATUS;
    if (statusModalType === "resolution")
      return STATUS_TYPE_OPEN_ORDER_RESOLUTION;
    return STATUS_TYPE_OPEN_ORDER;
  };

  const getActiveModalOptions = () => {
    if (statusModalType === "priority") return priorityOptions;
    if (statusModalType === "stock") return stockOptions;
    if (statusModalType === "subStatus") return subStatusOptions;
    if (statusModalType === "resolution") return resolutionOptions;
    return statusOptions;
  };

  const handleEditStatus = (index: number) => {
    const options = getActiveModalOptions();
    setEditingStatus({ index, value: options[index]?.label || "" });
  };

  const handleSaveStatus = async () => {
    if (editingStatus.index < 0 || !editingStatus.value.trim()) return;
    const options = getActiveModalOptions();
    const targetStatus = options[editingStatus.index];
    if (!targetStatus?.id) return;

    try {
      await updateStatus(targetStatus.id, {
        statusName: editingStatus.value.trim(),
        type: targetStatus.type || getModalTypeKey(),
      });
      // message.success("Status updated successfully");
      setEditingStatus({ index: -1, value: "" });
      await refreshOpenOrderStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update status",
      );
    }
  };

  const handleAddStatus = async () => {
    if (!newStatus.trim()) return;
    try {
      await createStatus({
        statusName: newStatus.trim(),
        type: getModalTypeKey(),
      });
      // message.success("Status added successfully");
      setNewStatus("");
      await refreshOpenOrderStatuses();
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add status");
    }
  };

  const handleDeleteStatus = async (index: number) => {
    const options = getActiveModalOptions();
    const targetStatus = options[index];
    if (!targetStatus?.id) return;
    try {
      await deleteStatus(targetStatus.id);
      // message.success("Status deleted successfully");
      await refreshOpenOrderStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete status",
      );
    }
  };

  // Fetch manufacturers from backend - FIXED with proper type checking
  const fetchManufacturers = useCallback(async () => {
    setManufacturersLoading(true);
    try {
      const response = await getManufacturers();
      console.log("Manufacturers API response:", response);

      // Check if response is an array
      if (Array.isArray(response)) {
        setManufacturers(response);
        console.log(`Loaded ${response.length} manufacturers from array`);
      }
      // Check if response has a data property that is an array
      else if (
        response &&
        typeof response === "object" &&
        "data" in response &&
        Array.isArray(response.data)
      ) {
        setManufacturers(response.data);
        console.log(
          `Loaded ${response.data.length} manufacturers from response.data`,
        );
      }
      // Check if response has a manufacturers property that is an array
      else if (
        response &&
        typeof response === "object" &&
        "manufacturers" in response &&
        Array.isArray(response.manufacturers)
      ) {
        setManufacturers(response.manufacturers);
        console.log(
          `Loaded ${response.manufacturers.length} manufacturers from response.manufacturers`,
        );
      }
      // If none of the above, try to convert object values to array if they look like manufacturers
      else if (response && typeof response === "object" && response !== null) {
        const possibleArray = Object.values(response);
        // Check if the first item has an id property (indicating it's a manufacturer)
        if (
          possibleArray.length > 0 &&
          possibleArray[0] &&
          typeof possibleArray[0] === "object" &&
          "id" in possibleArray[0]
        ) {
          setManufacturers(possibleArray as Manufacturer[]);
          console.log(
            `Loaded ${possibleArray.length} manufacturers from object values`,
          );
        } else {
          console.warn("Unexpected manufacturers data format:", response);
          setManufacturers([]);
        }
      } else {
        console.warn("No manufacturers data found");
        setManufacturers([]);
      }
    } catch (error) {
      console.error("Error fetching manufacturers:", error);
      message.error("Failed to load manufacturers");
      setManufacturers([]);
    } finally {
      setManufacturersLoading(false);
    }
  }, []);

  // Add manufacturer
  const handleAddManufacturer = async () => {
    if (!newManufacturerName.trim()) {
      message.warning("Please enter a manufacturer name");
      return;
    }

    try {
      const response = await createManufacturer({
        name: newManufacturerName.trim(),
      });
      setManufacturers([...manufacturers, response.data]);
      setNewManufacturerName("");
      // message.success("Manufacturer added successfully");
    } catch (error) {
      console.error("Error adding manufacturer:", error);
      message.error("Failed to add manufacturer");
    }
  };

  // Update manufacturer
  const handleUpdateManufacturer = async () => {
    if (!editingManufacturer?.name.trim()) {
      message.warning("Please enter a manufacturer name");
      return;
    }

    try {
      await updateManufacturer(editingManufacturer.id, {
        name: editingManufacturer.name.trim(),
      });
      setManufacturers(
        manufacturers.map((m) =>
          m.id === editingManufacturer.id
            ? { ...m, name: editingManufacturer.name.trim() }
            : m,
        ),
      );
      setEditingManufacturer(null);
      // message.success("Manufacturer updated successfully");
    } catch (error) {
      console.error("Error updating manufacturer:", error);
      message.error("Failed to update manufacturer");
    }
  };

  // Delete manufacturer
  const handleDeleteManufacturer = async (id: number, name: string) => {
    // Check if manufacturer is being used in any order item
    const isUsed = currentOrder.orderBlocks.some((block) =>
      block.items.some((item) => item.manu === name),
    );

    if (isUsed) {
      message.warning(
        `Cannot delete "${name}" because it's being used in this order`,
      );
      return;
    }

    try {
      await deleteManufacturer(id);
      setManufacturers(manufacturers.filter((m) => m.id !== id));
      // message.success("Manufacturer deleted successfully");
    } catch (error) {
      console.error("Error deleting manufacturer:", error);
      message.error("Failed to delete manufacturer");
    }
  };

  const fetchVendors = useCallback(async () => {
    setVendorsLoading(true);
    try {
      const response = await getVendors();

      if (Array.isArray(response)) {
        setVendors(response);
      } else if (
        response &&
        typeof response === "object" &&
        "data" in response &&
        Array.isArray(response.data)
      ) {
        setVendors(response.data);
      } else if (
        response &&
        typeof response === "object" &&
        "vendors" in response &&
        Array.isArray(response.vendors)
      ) {
        setVendors(response.vendors);
      } else {
        setVendors([]);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
      message.error("Failed to load vendors");
      setVendors([]);
    } finally {
      setVendorsLoading(false);
    }
  }, []);

  const refreshShipTos = async () => {
    try {
      const res = await getShipTos();
      setShipTos(Array.isArray(res?.data) ? res.data : []);
    } catch { /* silent */ }
  };

  const refreshCalTypes = async () => {
    try {
      const res = await getCalTypes();
      setCalTypes(Array.isArray(res?.data) ? res.data : []);
    } catch { /* silent */ }
  };

  const handleAddVendor = async () => {
    if (!newVendorName.trim()) {
      message.warning("Please enter a vendor name");
      return;
    }

    try {
      const response = await createVendor({
        name: newVendorName.trim(),
      });
      const createdVendor = response?.data || response;
      setVendors((prev) => [...prev, createdVendor]);
      setNewVendorName("");
    } catch (error) {
      console.error("Error adding vendor:", error);
      message.error("Failed to add vendor");
    }
  };

  const handleUpdateVendor = async () => {
    if (!editingVendor?.name.trim()) {
      message.warning("Please enter a vendor name");
      return;
    }

    try {
      const response = await updateVendor(editingVendor.id, {
        name: editingVendor.name.trim(),
      });
      const updatedVendor = response?.data || response;
      setVendors((prev) =>
        prev.map((vendor) =>
          vendor.id === editingVendor.id
            ? { ...vendor, name: updatedVendor?.name || editingVendor.name.trim() }
            : vendor,
        ),
      );
      setEditingVendor(null);
    } catch (error) {
      console.error("Error updating vendor:", error);
      message.error("Failed to update vendor");
    }
  };

  const handleDeleteVendor = async (id: number, name: string) => {
    const isUsed = currentOrder.orderBlocks.some((block) => block.vendor === name);

    if (isUsed) {
      message.warning(
        `Cannot delete "${name}" because it's being used in this order`,
      );
      return;
    }

    try {
      await deleteVendor(id);
      setVendors((prev) => prev.filter((vendor) => vendor.id !== id));
    } catch (error) {
      console.error("Error deleting vendor:", error);
      message.error("Failed to delete vendor");
    }
  };

  // Create empty order structure
  const createEmptyOrder = (): OpenOrderData => ({
    customer: "",
    custPo: "",
    expedite: "",
    priority: "",
    status: "",
    subStatus: "",
    stock: "",
    dateCreated: null,
    poDate: null,
    lastUpdate: null,
    resolution: "",
    quoteId: "",
    orderBlocks: [
      {
        vendor: "",
        poSent: null,
        pmtSent: null,
        items: [
          { model: "", qty: 0, manu: "", serial: "", options: "" },
          { model: "", qty: 0, manu: "", serial: "", options: "" },
          { model: "", qty: 0, manu: "", serial: "", options: "" },
        ],
        shipped: null,
        tracking: "",
        shipTo: "",
        calType: "",
        vendorComments: "",
        rmaNotes: "",
        generalComments: "",
        calLabComments: "",
      },
      {
        vendor: "",
        poSent: null,
        pmtSent: null,
        items: [
          { model: "", qty: 0, manu: "", serial: "", options: "" },
          { model: "", qty: 0, manu: "", serial: "", options: "" },
          { model: "", qty: 0, manu: "", serial: "", options: "" },
        ],
        shipped: null,
        tracking: "",
        shipTo: "",
        calType: "",
        vendorComments: "",
        rmaNotes: "",
        generalComments: "",
        calLabComments: "",
      },
      {
        vendor: "",
        poSent: null,
        pmtSent: null,
        items: [
          { model: "", qty: 0, manu: "", serial: "", options: "" },
          { model: "", qty: 0, manu: "", serial: "", options: "" },
          { model: "", qty: 0, manu: "", serial: "", options: "" },
        ],
        shipped: null,
        tracking: "",
        shipTo: "",
        calType: "",
        vendorComments: "",
        rmaNotes: "",
        generalComments: "",
        calLabComments: "",
      },
    ],
  });

  // Map state to API format
  const mapStateToApiFormat = (state: OpenOrderData): any => {
    const apiData: any = {
      id: state.id,
      customer: state.customer,
      cust_po: state.custPo,
      expedite: state.expedite,
    priority: state.priority,
    status: state.status,
    action: state.subStatus,
    stock: state.stock,
      date_created: state.dateCreated,
      po_date: state.poDate,
      last_update: new Date().toISOString(),
      resolution: state.resolution,
      quote_id: state.quoteId,
    };

    // Map each order block
    state.orderBlocks.forEach((block, blockIndex) => {
      const blockNum = blockIndex + 1;
      const suffix = blockNum === 1 ? "" : blockNum.toString();

      // Map block-level fields
      apiData[`vendor${suffix}`] = block.vendor;
      apiData[`po_sent${suffix}`] = block.poSent;
      apiData[`wire_sent${suffix}`] = block.pmtSent;
      apiData[`vendor_shipped${suffix}`] = block.shipped;
      apiData[`tracking_number${suffix}`] = block.tracking;
      apiData[`send_to${suffix}`] = block.shipTo;
      apiData[`cal_type_required${suffix}`] = block.calType;
      apiData[`vendor_comments${suffix}`] = block.vendorComments;
      apiData[`rma_notes${suffix}`] = block.rmaNotes;
      apiData[`general_comments${suffix}`] = block.generalComments;
      apiData[`cal_lab_comments${suffix}`] = block.calLabComments;

      // Map items
      block.items.forEach((item, itemIndex) => {
        const itemNum = itemIndex + 1;

        let modelKey = "";
        let qtyKey = "";
        let manuKey = "";
        let serialKey = "";
        let optKey = "";

        if (blockNum === 1) {
          if (itemNum === 1) {
            modelKey = "model";
            qtyKey = "qty";
            manuKey = "manu";
            serialKey = "serial_number1";
            optKey = "options";
          } else if (itemNum === 2) {
            modelKey = "model2";
            qtyKey = "qty2";
            manuKey = "manu2";
            serialKey = "serial_number2";
            optKey = "opt2";
          } else if (itemNum === 3) {
            modelKey = "model3";
            qtyKey = "qty3";
            manuKey = "manu3";
            serialKey = "serial_number3";
            optKey = "opt3";
          }
        } else if (blockNum === 2) {
          if (itemNum === 1) {
            modelKey = "model4";
            qtyKey = "qty4";
            manuKey = "manu4";
            serialKey = "serial_number4";
            optKey = "opt4";
          } else if (itemNum === 2) {
            modelKey = "model5";
            qtyKey = "qty5";
            manuKey = "manu5";
            serialKey = "serial_number5";
            optKey = "opt5";
          } else if (itemNum === 3) {
            modelKey = "model6";
            qtyKey = "qty6";
            manuKey = "manu6";
            serialKey = "serial_number6";
            optKey = "opt6";
          }
        } else if (blockNum === 3) {
          if (itemNum === 1) {
            modelKey = "model7";
            qtyKey = "qty7";
            manuKey = "manu7";
            serialKey = "serial_number7";
            optKey = "opt7";
          } else if (itemNum === 2) {
            modelKey = "model8";
            qtyKey = "qty8";
            manuKey = "manu8";
            serialKey = "serial_number8";
            optKey = "opt8";
          } else if (itemNum === 3) {
            modelKey = "model9";
            qtyKey = "qty9";
            manuKey = "manu9";
            serialKey = "serial_number9";
            optKey = "opt9";
          }
        }

        apiData[modelKey] = item.model;
        apiData[qtyKey] = item.qty;
        apiData[manuKey] = item.manu;
        apiData[serialKey] = item.serial;
        apiData[optKey] = item.options;
      });
    });

    return apiData;
  };

  // Map API data to state
  const mapApiDataToState = (apiData: any): OpenOrderData => {
    const orderBlocks: OrderBlockData[] = [];

    for (let blockIndex = 0; blockIndex < 3; blockIndex++) {
      const blockNum = blockIndex + 1;
      const suffix = blockNum === 1 ? "" : blockNum.toString();

      const items: OrderItem[] = [];

      let startItemNum = 1;
      if (blockNum === 1) startItemNum = 1;
      else if (blockNum === 2) startItemNum = 4;
      else if (blockNum === 3) startItemNum = 7;

      for (let itemIndex = 0; itemIndex < 3; itemIndex++) {
        const itemNum = startItemNum + itemIndex;

        let modelKey = "";
        let qtyKey = "";
        let manuKey = "";
        let serialKey = "";
        let optKey = "";

        if (itemNum === 1) {
          modelKey = "model";
          qtyKey = "qty";
          manuKey = "manu";
          serialKey = "serial_number1";
          optKey = "options";
        } else if (itemNum === 2) {
          modelKey = "model2";
          qtyKey = "qty2";
          manuKey = "manu2";
          serialKey = "serial_number2";
          optKey = "opt2";
        } else if (itemNum === 3) {
          modelKey = "model3";
          qtyKey = "qty3";
          manuKey = "manu3";
          serialKey = "serial_number3";
          optKey = "opt3";
        } else if (itemNum === 4) {
          modelKey = "model4";
          qtyKey = "qty4";
          manuKey = "manu4";
          serialKey = "serial_number4";
          optKey = "opt4";
        } else if (itemNum === 5) {
          modelKey = "model5";
          qtyKey = "qty5";
          manuKey = "manu5";
          serialKey = "serial_number5";
          optKey = "opt5";
        } else if (itemNum === 6) {
          modelKey = "model6";
          qtyKey = "qty6";
          manuKey = "manu6";
          serialKey = "serial_number6";
          optKey = "opt6";
        } else if (itemNum === 7) {
          modelKey = "model7";
          qtyKey = "qty7";
          manuKey = "manu7";
          serialKey = "serial_number7";
          optKey = "opt7";
        } else if (itemNum === 8) {
          modelKey = "model8";
          qtyKey = "qty8";
          manuKey = "manu8";
          serialKey = "serial_number8";
          optKey = "opt8";
        } else if (itemNum === 9) {
          modelKey = "model9";
          qtyKey = "qty9";
          manuKey = "manu9";
          serialKey = "serial_number9";
          optKey = "opt9";
        }

        items.push({
          model: apiData[modelKey] || "",
          qty: apiData[qtyKey] || 0,
          manu: apiData[manuKey] || "",
          serial: apiData[serialKey] || "",
          options: apiData[optKey] || "",
        });
      }

      orderBlocks.push({
        vendor: apiData[`vendor${suffix}`] || "",
        poSent: apiData[`po_sent${suffix}`] || null,
        pmtSent: apiData[`wire_sent${suffix}`] || null,
        items,
        shipped: apiData[`vendor_shipped${suffix}`] || null,
        tracking: apiData[`tracking_number${suffix}`] || "",
        shipTo: apiData[`send_to${suffix}`] || "",
        calType: apiData[`cal_type_required${suffix}`] || "",
        vendorComments: apiData[`vendor_comments${suffix}`] || "",
        rmaNotes: apiData[`rma_notes${suffix}`] || "",
        generalComments: apiData[`general_comments${suffix}`] || "",
        calLabComments: apiData[`cal_lab_comments${suffix}`] || "",
      });
    }

    return {
      id: apiData.id,
      customer: apiData.customer || "",
      custPo: apiData.cust_po || "",
      expedite: apiData.expedite || "",
      priority: apiData.priority || "",
      status: apiData.status || "",
      subStatus: apiData.action || apiData.sub_status || "",
      stock: apiData.stock || "",
      dateCreated:
        apiData.date_created ||
        apiData.created_at ||
        apiData.createdAt ||
        null,
      poDate: apiData.po_date || null,
      lastUpdate: apiData.last_update || null,
      resolution: apiData.resolution || "",
      quoteId: apiData.quote_id || "",
      orderBlocks,
    };
  };

  // Auto-save function
  const performSave = useCallback(async (orderToSave: OpenOrderData) => {
    if (!orderToSave) return;

    let savedExisting = false;

    try {
      const apiData = mapStateToApiFormat(orderToSave);

      if (orderToSave.id) {
        await updateOpenOrder(orderToSave.id, apiData);
        savedExisting = true;
      } else {
        const apiValues = Object.values(apiData).filter((v) => v !== null && v !== undefined && v !== "");
        if (apiValues.length > 0) {
          const newOrder = await createOpenOrder(apiData);
          const mappedNew = mapApiDataToState(newOrder);
          setCurrentOrder(mappedNew);
          setTotalRecords((prev) => {
            const newTotal = prev + 1;
            setCurrentPage(newTotal - 1);
            return newTotal;
          });
        }
      }
    } catch (error) {
      console.error("Error saving:", error);
    }

    // Fields edited in this pass that also live on the quote's Order Tracking
    // record. Silent by design — nothing is surfaced either way.
    const blockIndexes = Array.from(pendingTrackingSyncRef.current);
    const syncCustPo = pendingCustPoSyncRef.current;
    const serialItems = Array.from(pendingSerialSyncRef.current);
    pendingTrackingSyncRef.current.clear();
    pendingCustPoSyncRef.current = false;
    pendingSerialSyncRef.current.clear();
    if (savedExisting && (blockIndexes.length || syncCustPo || serialItems.length)) {
      await syncOpenOrderToOrderTracking(orderToSave, { blockIndexes, syncCustPo, serialItems });
    }
  }, []);

  // Debounced save
  const scheduleAutoSave = useCallback(
    (updatedOrder: OpenOrderData) => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }

      saveTimeoutRef.current = setTimeout(() => {
        performSave(updatedOrder);
      }, 1500);
    },
    [performSave],
  );

  // Handle field updates
  const handleFieldUpdate = (field: string, value: any) => {
    if (field === "custPo") {
      pendingCustPoSyncRef.current = true;
    }
    setCurrentOrder((prev) => {
      const updated = {
        ...prev,
        [field]: value,
      };
      scheduleAutoSave(updated);
      return updated;
    });
  };

  // Handle block updates
  const handleBlockUpdate = (
    blockIndex: number,
    field: string,
    value: any,
    itemIndex?: number,
  ) => {
    setCurrentOrder((prev) => {
      const newOrderBlocks = [...prev.orderBlocks];

      if (field.startsWith("items.") && itemIndex !== undefined) {
        const fieldPath = field.split(".");
        const actualField = fieldPath[2];

        newOrderBlocks[blockIndex].items[itemIndex] = {
          ...newOrderBlocks[blockIndex].items[itemIndex],
          [actualField]: value,
        };
        if (actualField === "serial") {
          pendingSerialSyncRef.current.add(`${blockIndex}:${itemIndex}`);
        }
      } else {
        (newOrderBlocks[blockIndex] as any)[field] = value;
        if (field === "tracking") {
          pendingTrackingSyncRef.current.add(blockIndex);
        }
      }

      const updated = {
        ...prev,
        orderBlocks: newOrderBlocks,
      };

      scheduleAutoSave(updated);
      return updated;
    });
  };

  // Fetch total count
  const fetchTotalCount = useCallback(async (
    statusFilter: string | null = null,
    todayFilter = false,
    subStatusFilter: string | null = null,
    rulesOverride = sortRules,
  ) => {
    try {

      if (statusFilter || todayFilter || subStatusFilter) {
        const params: any = { limit: 10000, page: 1, ...buildSortParams(rulesOverride) };
        if (statusFilter) {
          params.status = statusFilter;
        }
        if (todayFilter) {
          params.today = true;
        }
        if (subStatusFilter) {
          params.subStatus = subStatusFilter;
        }

        const [response, unfilteredResp] = await Promise.all([
          getOpenOrders(params),
          getOpenOrders({ limit: 1, page: 1 }),
        ]);
        const rows = extractRows(response);
        const unfilteredRows = extractRows(unfilteredResp);
        setFilteredRecords(rows);
        setTotalRecords(rows.length);
        setUnfilteredTotal(
          unfilteredResp?.pagination?.total ?? unfilteredRows.length ?? 0,
        );

        if (rows.length > 0) {
          setCurrentOrder(mapApiDataToState(rows[0]));
        } else {
          setCurrentOrder(createEmptyOrder());
        }
        setCurrentPage(0);
        return;
      }

      const response = await getOpenOrders({ limit: 1, page: 1, ...buildSortParams(rulesOverride) });
      const rows = extractRows(response);
      const total = response?.pagination?.total ?? rows.length ?? 0;
      setFilteredRecords(null);
      setTotalRecords(total);
      setUnfilteredTotal(total);

      if (rows.length > 0) {
        setCurrentOrder(mapApiDataToState(rows[0]));
        setCurrentPage(0);
      } else {
        setCurrentOrder(createEmptyOrder());
        setCurrentPage(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to load data");
    }
  }, []);

  // Fetch record by page
  const fetchRecord = useCallback(
    async (pageIndex: number, rulesOverride = sortRules) => {
      if (Array.isArray(filteredRecords)) {
        const record = filteredRecords[pageIndex];
        if (record) {
          setCurrentOrder(mapApiDataToState(record));
          setCurrentPage(pageIndex);
        }
        return;
      }

      setLoading(true);
      try {
        const params: any = { limit: 1, page: pageIndex + 1, ...buildSortParams(rulesOverride) };
        const response = await getOpenOrders(params);
        const rows = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : Array.isArray(response?.rows)
              ? response.rows
              : Array.isArray(response?.records)
                ? response.records
                : [];
        if (rows.length > 0) {
          setCurrentOrder(mapApiDataToState(rows[0]));
          setCurrentPage(pageIndex);
        }
      } catch (error) {
        console.error("Error fetching record:", error);
        message.error("Failed to load record");
      } finally {
        setLoading(false);
      }
    },
    [filteredRecords, sortRules],
  );

  const applyStatusFilter = async (status: string) => {
    preFilterPageRef.current = currentPage;
    setActiveStatusFilter(status);
    setActiveTodayFilter(false);
    setActiveRmaFilter(false);
    await fetchTotalCount(status, false, null);
  };

  const findStatusValueByLabel = (label: string) => {
    const match = statusOptions.find(
      (opt) => String(opt.value || "").toLowerCase() === label.toLowerCase(),
    );
    return match?.value || label;
  };

  const emptyFindFields = { customer: "", custPo: "", quoteId: "", status: "", subStatus: "", priority: "", resolution: "", manu: "", model: "", vendor: "", serialNumber: "", expedite: "", stock: "", options: "", tracking: "", shipTo: "", calType: "", vendorComments: "", rmaNotes: "", calLabComments: "", generalComments: "", qty: "", poDate: "", poSent: "", pmtSent: "", shipped: "" };

  const openFindMode = () => {
    setFindFields(emptyFindFields);
    setIsFindMode(true);
  };

  const cancelFindMode = async () => {
    setIsFindMode(false);
    setFindFields(emptyFindFields);
    setFilteredRecords(null);
    setActiveStatusFilter(null);
    setActiveTodayFilter(false);
    setActiveRmaFilter(false);
    // Clear find from localStorage and restore pre-filter position
    localStorage.setItem(OO_STATE_KEY, JSON.stringify({
      currentPage: preFilterPageRef.current,
      isFindMode: false,
      findFields: emptyFindFields,
      activeStatusFilter: null,
      activeTodayFilter: false,
      activeRmaFilter: false,
      unfilteredTotal,
    }));
    await fetchTotalCount();
    if (preFilterPageRef.current > 0) fetchRecord(preFilterPageRef.current);
  };

  const handlePerformFind = async () => {
    const f = findFields;
    const hasAny = Object.values(f).some((v) => v.trim());
    if (!hasAny) { message.warning("Enter at least one search value"); return; }
    preFilterPageRef.current = currentPage;
    const params: any = { limit: 10000, page: 1, ...buildSortParams() };
    if (f.customer)     params.customer     = f.customer.trim();
    if (f.quoteId)      params.quoteId      = f.quoteId.trim();
    if (f.custPo)       params.custPo       = f.custPo.trim();
    if (f.status)       params.status       = f.status.trim();
    if (f.subStatus)    params.subStatus    = f.subStatus.trim();
    if (f.priority)     params.priority     = f.priority.trim();
    if (f.resolution)   params.resolution   = f.resolution.trim();
    if (f.manu)         params.manu         = f.manu.trim();
    if (f.model)        params.model        = f.model.trim();
    if (f.vendor)       params.vendor       = f.vendor.trim();
    if (f.serialNumber) params.serialNumber = f.serialNumber.trim();
    if (f.expedite)        params.expedite        = f.expedite.trim();
    if (f.stock)           params.stock           = f.stock.trim();
    if (f.options)         params.options         = f.options.trim();
    if (f.tracking)        params.tracking        = f.tracking.trim();
    if (f.shipTo)          params.shipTo          = f.shipTo.trim();
    if (f.calType)         params.calType         = f.calType.trim();
    if (f.vendorComments)  params.vendorComments  = f.vendorComments.trim();
    if (f.rmaNotes)        params.rmaNotes        = f.rmaNotes.trim();
    if (f.calLabComments)  params.calLabComments  = f.calLabComments.trim();
    if (f.generalComments) params.generalComments = f.generalComments.trim();
    if (f.qty)             params.qty             = f.qty.trim();
    if (f.poDate)          params.poDate          = f.poDate.trim();
    if (f.poSent)          params.poSent          = f.poSent.trim();
    if (f.pmtSent)         params.pmtSent         = f.pmtSent.trim();
    if (f.shipped)         params.shipped         = f.shipped.trim();
    try {
      const response = await getOpenOrders(params);
      const rows = extractRows(response);
      setFilteredRecords(rows);
      setTotalRecords(rows.length);
      setCurrentPage(0);
      if (rows.length > 0) setCurrentOrder(mapApiDataToState(rows[0]));
      else setCurrentOrder(createEmptyOrder());
      setActiveStatusFilter(null);
      setActiveTodayFilter(false);
      setActiveRmaFilter(false);
    } catch (err: any) { message.error(err?.response?.data?.message || "Search failed"); }
    setIsFindMode(false);
  };

  const handleFindOpen = async () => {
    await applyStatusFilter(findStatusValueByLabel("Open"));
  };

  const handleFindAdmin = async () => {
    await applyStatusFilter(findStatusValueByLabel("Admin"));
  };

  const handleFindToday = async () => {
    preFilterPageRef.current = currentPage;
    setActiveStatusFilter(null);
    setActiveTodayFilter(true);
    setActiveRmaFilter(false);
    await fetchTotalCount(null, true, null);
  };

  const handleFindRMA = async () => {
    preFilterPageRef.current = currentPage;
    setActiveStatusFilter(null);
    setActiveTodayFilter(false);
    setActiveRmaFilter(true);
    await fetchTotalCount(null, false, "RMA");
  };

  const clearStatusFilter = async () => {
    setActiveStatusFilter(null);
    setActiveTodayFilter(false);
    setActiveRmaFilter(false);
    setFindFields(emptyFindFields);
    setFilteredRecords(null);
    setSortRules([]);
    // Clear filter from localStorage and restore pre-filter position
    localStorage.setItem(OO_STATE_KEY, JSON.stringify({
      currentPage: preFilterPageRef.current,
      isFindMode: false,
      findFields: emptyFindFields,
      activeStatusFilter: null,
      activeTodayFilter: false,
      activeRmaFilter: false,
      unfilteredTotal,
      sortRules: [],
    }));
    await fetchTotalCount(null, false, null, []);
    if (preFilterPageRef.current > 0) fetchRecord(preFilterPageRef.current, []);
  };

  useEffect(() => {
    setRecordInputValue(totalRecords > 0 ? String(currentPage + 1) : "");
  }, [currentPage, totalRecords]);

  const handleRecordInputCommit = (value: string) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1 || n > totalRecords) {
      setRecordInputValue(totalRecords > 0 ? String(currentPage + 1) : "");
      return;
    }

    fetchRecord(n - 1);
  };

  // Navigation handlers
  const handlePrevious = () => {
    if (currentPage > 0) {
      fetchRecord(currentPage - 1);
    } else {
      message.info("Already at first record");
    }
  };

  const handleNext = () => {
    if (currentPage + 1 < totalRecords) {
      fetchRecord(currentPage + 1);
    } else {
      message.info("Already at last record");
    }
  };

  const handleNewRecord = () => {
    if (activeStatusFilter || activeTodayFilter || activeRmaFilter) {
      clearStatusFilter();
    }
    setCurrentOrder(createEmptyOrder());
    setCurrentPage(totalRecords);
  };

  const handleDeleteCurrentRecord = async () => {
    if (!currentOrder?.id) {
      message.warning("No saved open order record selected to delete");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete this open order record?",
    );
    if (!confirmed) return;

    try {
      await deleteOpenOrder(currentOrder.id);
      // message.success("Open order record deleted successfully");

      if (Array.isArray(filteredRecords)) {
        const remaining = filteredRecords.filter(
          (row: any) => Number(row?.id) !== Number(currentOrder.id),
        );
        setFilteredRecords(remaining);
        setTotalRecords(remaining.length);

        if (remaining.length > 0) {
          const nextIndex = Math.min(currentPage, remaining.length - 1);
          setCurrentPage(nextIndex);
          setCurrentOrder(mapApiDataToState(remaining[nextIndex]));
        } else {
          setCurrentPage(0);
          setCurrentOrder(createEmptyOrder());
        }
        return;
      }

      await fetchTotalCount(activeStatusFilter, activeTodayFilter, activeRmaFilter ? "RMA" : null);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete open order record",
      );
    }
  };

  const withQuoteId = (path: string) => path;

  // Legacy button styles matching the original Open Order Report
  const btnNewRecord =
    "bg-[#99ccff] text-black border border-[#99ccff] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#99ccff] font-bold";
  const btnFind =
    "bg-[#ffff66] text-black border border-[#ffff66] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ffff66] font-bold";
  const btnFindToday =
    "bg-[#99ffff] text-black border border-[#99ffff] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#99ffff] font-bold";
  const btnFindAdmin =
    "bg-[#ffccff] text-black border border-[#ffccff] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ffccff] font-bold";
  const btnNav =
    "bg-[#ccccff] text-black border border-[#ccccff] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ccccff] font-bold";
  const btnEQR =
    "bg-[#ff5800] text-black border border-[#ff5800] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ff5800] font-bold";
  const btnOTC =
    "bg-[#ff00ff] text-black border border-[#ff00ff] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ff00ff] font-bold";
  const btnINV =
    "bg-[#99ffff] text-black border border-[#99ffff] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#99ffff] font-bold";
  const btnQuotes =
    "bg-[#ff6666] text-black border border-[#ff6666] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ff6666] font-bold";
  const btnEBOT =
    "bg-[#ffcc99] text-black border border-[#ffcc99] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#ffcc99] font-bold";
  const btnDelete =
    "bg-[#f0f0f0] text-black border border-[#808080] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#e0e0e0] font-bold";
  const btnFindRMA =
    "bg-[#f0f0f0] text-black border border-[#808080] text-[11px] px-3 h-7 rounded-sm shadow-sm hover:bg-[#e0e0e0] font-bold";
  const pageHeaderButtonBase =
    "text-black border text-[12px] px-3 h-[24px] rounded-none shadow-none font-normal leading-none flex items-center justify-center";

  useEffect(() => {
    localStorage.setItem(OO_STATE_KEY, JSON.stringify({ currentPage, isFindMode, findFields, activeStatusFilter, activeTodayFilter, activeRmaFilter, unfilteredTotal, sortRules }));
  }, [currentPage, isFindMode, findFields, activeStatusFilter, activeTodayFilter, activeRmaFilter, unfilteredTotal, sortRules]);

  useEffect(() => {
    const init = async () => {
      const openQuoteId = String(
        (location.state as any)?.openQuoteId || "",
      ).trim();

      if (openQuoteId) {
        try {
          const response = await getOpenOrders({
            limit: 10000,
            page: 1,
            quoteId: openQuoteId,
            ...buildSortParams(),
          });
          const rows = extractRows(response);
          if (rows.length > 0) {
            setIsFindMode(false);
            setFindFields({ ...emptyFindFields, quoteId: openQuoteId });
            setFilteredRecords(rows);
            setTotalRecords(rows.length);
            setCurrentPage(0);
            setCurrentOrder(mapApiDataToState(rows[0]));
            navigate(location.pathname, { replace: true });
            return;
          } else {
            message.warning(
              `No Open Order record found for Quote ID ${openQuoteId}. Showing the last opened Open Order record.`,
            );
            navigate(location.pathname, { replace: true });
          }
        } catch (error: any) {
          message.error(
            error?.response?.data?.message ||
              `Failed to open Quote ID ${openQuoteId}`,
          );
          navigate(location.pathname, { replace: true });
        }
      }

      const savedFind = _ooSaved.findFields || {};
      const hasSavedFind = Object.values(savedFind).some((v) => String(v || "").trim());
      if (hasSavedFind) {
        // Re-apply saved find criteria
        const params: any = { limit: 10000, page: 1, ...buildSortParams() };
        if (savedFind.customer)     params.customer     = savedFind.customer.trim();
        if (savedFind.quoteId)      params.quoteId      = savedFind.quoteId.trim();
        if (savedFind.custPo)       params.custPo       = savedFind.custPo.trim();
        if (savedFind.status)       params.status       = savedFind.status.trim();
        if (savedFind.subStatus)    params.subStatus    = savedFind.subStatus.trim();
        if (savedFind.priority)     params.priority     = savedFind.priority.trim();
        if (savedFind.resolution)   params.resolution   = savedFind.resolution.trim();
        if (savedFind.manu)         params.manu         = savedFind.manu.trim();
        if (savedFind.model)        params.model        = savedFind.model.trim();
        if (savedFind.vendor)       params.vendor       = savedFind.vendor.trim();
        if (savedFind.serialNumber) params.serialNumber = savedFind.serialNumber.trim();
        try {
          const response = await getOpenOrders(params);
          const rows = extractRows(response);
          setFilteredRecords(rows);
          setTotalRecords(rows.length);
          const savedPage = _ooSaved.currentPage || 0;
          const record = rows[savedPage];
          if (record) { setCurrentOrder(mapApiDataToState(record)); setCurrentPage(savedPage); }
          else if (rows.length > 0) { setCurrentOrder(mapApiDataToState(rows[0])); setCurrentPage(0); }
        } catch { await fetchTotalCount(); }
      } else if (_ooSaved.activeStatusFilter || _ooSaved.activeTodayFilter || _ooSaved.activeRmaFilter) {
        await fetchTotalCount(
          _ooSaved.activeStatusFilter || null,
          _ooSaved.activeTodayFilter || false,
          _ooSaved.activeRmaFilter ? "RMA" : null,
        );
        if (_ooSaved.currentPage > 0) fetchRecord(_ooSaved.currentPage);
      } else {
        await fetchTotalCount();
        if (_ooSaved.currentPage > 0) fetchRecord(_ooSaved.currentPage);
      }
    };
    init();
    fetchManufacturers();
    fetchVendors();
    refreshShipTos();
    refreshCalTypes();
    refreshOpenOrderStatuses();
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, []);

  const handleApplySortRules = async (rules: SortRule[]) => {
    const normalized = normalizeSortRules(rules, OPEN_ORDER_SORT_KEYS);
    setSortRules(normalized);
    setFilteredRecords(null);
    setCurrentPage(0);
    await fetchTotalCount(null, false, null, normalized);
  };

  // Add navigation handlers for each button
  const handleOrderTrackingCenter = () => {
    navigate("/order-tracking");
  };

  // Flatten this Open Order record's line items into Order Tracking's 5-slot
  // shape: manu/model/qty/serial come from the first 5 of the up-to-9 item
  // slots (blocks 0-1, items 0-2/0-2), vendor/tracking come from the up-to-3
  // block-level slots (Order Tracking has room for 5, Open Order only has 3).
  const buildOrderTrackingDraftFromOpenOrder = () => {
    const items: { manu: string; model: string; qty: string; serial: string }[] = [];
    (currentOrder.orderBlocks || []).forEach((block: any) => {
      (block.items || []).forEach((item: any) => {
        items.push({
          manu: item?.manu || "",
          model: item?.model || "",
          qty: item?.qty != null ? String(item.qty) : "",
          serial: item?.serial || "",
        });
      });
    });
    const slot = (i: number) => items[i] || { manu: "", model: "", qty: "", serial: "" };

    const blocks = currentOrder.orderBlocks || [];
    const vendorSlot = (i: number) => blocks[i]?.vendor || "";
    const trackingSlot = (i: number) => blocks[i]?.tracking || "";

    return {
      quoteId: currentOrder.quoteId || "",
      customer: currentOrder.customer || "",
      custPo: currentOrder.custPo || "",
      manu: slot(0).manu, model: slot(0).model, qty: slot(0).qty, sn: slot(0).serial,
      manu2: slot(1).manu, model2: slot(1).model, qty2: slot(1).qty, sn2: slot(1).serial,
      manu3: slot(2).manu, model3: slot(2).model, qty3: slot(2).qty, sn3: slot(2).serial,
      manu4: slot(3).manu, model4: slot(3).model, qty4: slot(3).qty, sn4: slot(3).serial,
      manu5: slot(4).manu, model5: slot(4).model, qty5: slot(4).qty, sn5: slot(4).serial,
      vendor: vendorSlot(0), trackingNo: trackingSlot(0),
      vendor2: vendorSlot(1), trackingNo2: trackingSlot(1),
      vendor3: vendorSlot(2), trackingNo3: trackingSlot(2),
    };
  };

  const handleOpenSendToOrderTracking = () => {
    setSendToOrderTrackingDraft(buildOrderTrackingDraftFromOpenOrder());
    setIsSendToOrderTrackingOpen(true);
  };

  const handleSaveSendToOrderTracking = async () => {
    if (!sendToOrderTrackingDraft) return;
    setSendToOrderTrackingSaving(true);
    try {
      const d = sendToOrderTrackingDraft;
      await createOrderTracking({
        quote_id: d.quoteId || null,
        customer: d.customer || null,
        po_number: d.custPo || null,
        manu: d.manu || null,
        model: d.model || null,
        serial_num1: d.sn || null,
        qty: d.qty ? Number.parseInt(d.qty, 10) || null : null,
        vendor: d.vendor || null,
        tracking_no: d.trackingNo || null,
        manu2: d.manu2 || null,
        model_2: d.model2 || null,
        serial_num2: d.sn2 || null,
        qty_2: d.qty2 ? Number.parseInt(d.qty2, 10) || null : null,
        vendor2: d.vendor2 || null,
        tracking_no_2: d.trackingNo2 || null,
        manu3: d.manu3 || null,
        model_3: d.model3 || null,
        serial_num3: d.sn3 || null,
        qty_3: d.qty3 ? Number.parseInt(d.qty3, 10) || null : null,
        vendor3: d.vendor3 || null,
        tracking_no_3: d.trackingNo3 || null,
        manu4: d.manu4 || null,
        model_4: d.model4 || null,
        serial_num4: d.sn4 || null,
        qty_4: d.qty4 ? Number.parseInt(d.qty4, 10) || null : null,
        tracking_no_4: d.trackingNo4 || null,
        manu5: d.manu5 || null,
        model_5: d.model5 || null,
        serial_num5: d.sn5 || null,
        qty_5: d.qty5 ? Number.parseInt(d.qty5, 10) || null : null,
        tracking_no_5: d.trackingNo5 || null,
      });
      message.success("Added to Order Tracking");
      setIsSendToOrderTrackingOpen(false);
      setSendToOrderTrackingDraft(null);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to add to Order Tracking",
      );
    } finally {
      setSendToOrderTrackingSaving(false);
    }
  };

  const handleEQR = () => {
    navigate("/eqr");
  };

  const handleOTCSnapshot = () => {
    navigate("/otc");
  };

  const handleINV = () => {
    navigate("/inventory");
  };

  const handleQuotes = () => {
    navigate("/Quotes");
  };

  const handleEBOT = () => {
    navigate("/ebot");
  };

  return (
    <div
      className="min-h-screen p-2 font-sans text-gray-700"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      {/* HEADER SECTION */}
      <div className="mb-2">
        <CommonHeader
          className="mb-0"
          currentRecord={recordInputValue}
          disableNext={totalRecords > 0 && currentPage + 1 >= totalRecords}
          disablePrevious={currentPage === 0 || totalRecords === 0}
          isFindMode={isFindMode}
          onCancelFind={cancelFindMode}
          onDeleteRecord={handleDeleteCurrentRecord}
          onFind={openFindMode}
          onPerformFind={handlePerformFind}
          onNewRecord={handleNewRecord}
          onNextRecord={handleNext}
          onPreviousRecord={handlePrevious}
          onRecordChange={setRecordInputValue}
          onRecordCommit={handleRecordInputCommit}
          onRecordSliderCommit={(index) => fetchRecord(index)}
          onShowAll={clearStatusFilter}
          recordCount={totalRecords}
          recordIndex={Math.min(currentPage, Math.max(totalRecords - 1, 0))}
          rightContent={<PageLogoutButton />}
          totalActiveCount={totalRecords}
          totalLabel={activeStatusFilter || activeTodayFilter || activeRmaFilter ? "Filtered" : (sortRules.length > 0 ? "Total (Sorted)" : "Total (Unsorted)")}
          totalRecordCount={unfilteredTotal}
          totalValue={
            activeStatusFilter || activeTodayFilter || activeRmaFilter
              ? `${totalRecords} / ${unfilteredTotal}`
              : totalRecords
          }
          withQuoteId={withQuoteId}
          sortColumns={OPEN_ORDER_EXPORT_COLUMNS}
          sortTitle="Sort Open Order Report Records"
          sortRules={sortRules}
          onApplySort={handleApplySortRules}
          exportColumns={OPEN_ORDER_EXPORT_COLUMNS}
          getData={() => dataSource.map((r) => {
            const b = (i: number) => r.orderBlocks?.[i] || {} as any;
            const item = (blockIdx: number, itemIdx: number) => b(blockIdx).items?.[itemIdx] || {} as any;
            return {
              quoteId: r.quoteId, customer: r.customer, custPo: r.custPo, priority: r.priority,
              expedite: r.expedite, status: r.status, subStatus: r.subStatus,
              stock: r.stock, poDate: r.poDate, dateCreated: r.dateCreated,
              lastUpdate: r.lastUpdate, resolution: r.resolution,
              // Block 1
              vendor1: b(0).vendor, poSent1: b(0).poSent, pmtSent1: b(0).pmtSent,
              shipped1: b(0).shipped, tracking1: b(0).tracking, shipTo1: b(0).shipTo,
              calType1: b(0).calType, vendorComments1: b(0).vendorComments,
              rmaNotes1: b(0).rmaNotes, generalComments1: b(0).generalComments,
              calLabComments1: b(0).calLabComments,
              manu1: item(0,0).manu, model1: item(0,0).model, qty1: item(0,0).qty, serial1: item(0,0).serial, options1: item(0,0).options,
              manu2: item(0,1).manu, model2: item(0,1).model, qty2: item(0,1).qty, serial2: item(0,1).serial, options2: item(0,1).options,
              manu3: item(0,2).manu, model3: item(0,2).model, qty3: item(0,2).qty, serial3: item(0,2).serial, options3: item(0,2).options,
              // Block 2
              vendor2: b(1).vendor, poSent2: b(1).poSent, pmtSent2: b(1).pmtSent,
              shipped2: b(1).shipped, tracking2: b(1).tracking, shipTo2: b(1).shipTo,
              calType2: b(1).calType, vendorComments2: b(1).vendorComments,
              rmaNotes2: b(1).rmaNotes, generalComments2: b(1).generalComments,
              calLabComments2: b(1).calLabComments,
              manu4: item(1,0).manu, model4: item(1,0).model, qty4: item(1,0).qty, serial4: item(1,0).serial, options4: item(1,0).options,
              manu5: item(1,1).manu, model5: item(1,1).model, qty5: item(1,1).qty, serial5: item(1,1).serial, options5: item(1,1).options,
              manu6: item(1,2).manu, model6: item(1,2).model, qty6: item(1,2).qty, serial6: item(1,2).serial, options6: item(1,2).options,
              // Block 3
              vendor3: b(2).vendor, poSent3: b(2).poSent, pmtSent3: b(2).pmtSent,
              shipped3: b(2).shipped, tracking3: b(2).tracking, shipTo3: b(2).shipTo,
              calType3: b(2).calType, vendorComments3: b(2).vendorComments,
              rmaNotes3: b(2).rmaNotes, generalComments3: b(2).generalComments,
              calLabComments3: b(2).calLabComments,
              manu7: item(2,0).manu, model7: item(2,0).model, qty7: item(2,0).qty, serial7: item(2,0).serial, options7: item(2,0).options,
              manu8: item(2,1).manu, model8: item(2,1).model, qty8: item(2,1).qty, serial8: item(2,1).serial, options8: item(2,1).options,
              manu9: item(2,2).manu, model9: item(2,2).model, qty9: item(2,2).qty, serial9: item(2,2).serial, options9: item(2,2).options,
            };
          })}
          onImport={async (data) => { await bulkImportOpenOrders(data); }}
          exportFilename="open-orders"
        />

        <div className="flex min-h-[46px] items-center border-b-[10px] border-b-[#37669c] bg-white px-5">
          <h1
            className="mr-[132px] whitespace-nowrap text-[30px] font-bold leading-none"
            style={{ color: "#37669c" }}
          >
            Open Order Report
          </h1>

          <div className="flex flex-1 items-center gap-0">
          <Button className={`${pageHeaderButtonBase} bg-[#99ccff] border-[#111111] min-w-[100px]`} onClick={handleNewRecord}>
            New Record
          </Button>
          <div className="w-2" />
          <Button className={`${pageHeaderButtonBase} bg-[#ccffcc] border-[#111111] min-w-[140px]`} onClick={handleOpenSendToOrderTracking}>
            Send to Order Tracking
          </Button>
          <div className="w-4" />
          <Button className={`${pageHeaderButtonBase} bg-[#ffff66] border-[#111111] min-w-[70px]`} onClick={handleFindOpen}>
            Find Open
          </Button>
          <Button className={`${pageHeaderButtonBase} bg-[#99ffff] border-[#111111] min-w-[98px]`} onClick={handleFindToday}>
            Find Today's
          </Button>
          <Button className={`${pageHeaderButtonBase} bg-[#ffccff] border-[#111111] min-w-[98px]`} onClick={handleFindAdmin}>
            Find Admin
          </Button>
          <div className="w-4" />
          <Button className={`${pageHeaderButtonBase} bg-[#ccccff] border-[#111111] min-w-[130px]`} onClick={handleOrderTrackingCenter}>
            Order Tracking Center
          </Button>
          <Button className={`${pageHeaderButtonBase} bg-[#ff5800] border-[#111111] min-w-[46px]`} onClick={handleEQR}>
            EQR
          </Button>
          <Button className={`${pageHeaderButtonBase} bg-[#ff00ff] border-[#111111] min-w-[96px]`} onClick={handleOTCSnapshot}>
            OTC Snapshot
          </Button>
          <Button className={`${pageHeaderButtonBase} bg-[#99ffff] border-[#111111] min-w-[44px]`} onClick={handleINV}>
            INV
          </Button>
          <Button className={`${pageHeaderButtonBase} bg-[#ff6666] border-[#111111] min-w-[64px]`} onClick={handleQuotes}>
            Quotes
          </Button>
          <div className="flex-1" />
          <Button className={`${pageHeaderButtonBase} bg-[#ffcc99] border-[#111111] min-w-[98px]`} onClick={handleEBOT}>
            EBOT
          </Button>
          </div>
        </div>
      </div>

      <Spin spinning={loading && totalRecords > 0}>
        {/* STATUS BAR & CUSTOMER INFO */}
        <div className="p-2 rounded" style={{ backgroundColor: "#FFFFFF" }}>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 pb-2 text-xs">
            <div className="flex items-center gap-2">
              <span className="font-bold text-black text-[11px]">
                Last Update
              </span>
              <Input
                value={
                  currentOrder.lastUpdate
                    ? dayjs(currentOrder.lastUpdate).format(
                        "MM/DD/YYYY hh:mm A",
                      )
                    : ""
                }
                className="Allinput !h-[28px] text-xs font-bold text-black w-36"
                style={{ backgroundColor: "#ffff00" }}
                readOnly
              />
            </div>

            <div className="flex items-center gap-2">
              <span className="font-bold text-black text-[11px]">Status</span>
              {isFindMode ? (
                <Select value={findFields.status || undefined} allowClear size="small" className="w-24 text-xs custom" placeholder="Search..." autoFocus options={statusOptions.map((opt) => ({ value: opt.value, label: opt.label }))} onChange={(value) => setFindFields((p) => ({ ...p, status: value || "" }))} />
              ) : (
                <Select value={currentOrder.status} allowClear onChange={(value) => { if (value === "edit_status") { setStatusModalType("status"); setIsStatusModalOpen(true); return; } handleFieldUpdate("status", value ?? ""); }} size="small" className="w-24 text-xs custom" options={[...statusOptions.map((opt) => ({ value: opt.value, label: opt.label })), { value: "edit_status", label: "✎ Edit Status..." }]} />
              )}
            </div>

            <div className="flex items-center gap-2">
              <span className="font-bold text-black text-[11px]">Priority?</span>
              {isFindMode ? (
                <Select value={findFields.priority || undefined} allowClear size="small" className="w-24 text-xs custom" placeholder="Search..." options={priorityOptions.map((opt) => ({ value: opt.value, label: opt.label }))} onChange={(value) => setFindFields((p) => ({ ...p, priority: value || "" }))} />
              ) : (
                <Select value={currentOrder.priority} allowClear onChange={(value) => { if (value === "edit_priority") { setStatusModalType("priority"); setIsStatusModalOpen(true); return; } handleFieldUpdate("priority", value ?? ""); }} size="small" className="w-24 text-xs custom" options={[...priorityOptions.map((opt) => ({ value: opt.value, label: opt.label })), { value: "edit_priority", label: "Edit Priority..." }]} />
              )}
            </div>

            <div className="flex items-center gap-2">
              <span className="font-bold text-black text-[11px]">
                Expedite?
              </span>
              <Select
                className="w-36 text-xs"
                size="small"
                placeholder={isFindMode ? "Search..." : undefined}
                value={isFindMode ? (findFields.expedite || undefined) : (currentOrder.expedite || undefined)}
                onChange={(value) => isFindMode ? setFindFields((p) => ({ ...p, expedite: value || "" })) : handleFieldUpdate("expedite", value ?? "")}
                allowClear
                options={[
                  { value: "YES SEE NOTES !", label: "YES SEE NOTES !" },
                  { value: "NO", label: "NO" },
                ]}
              />
            </div>

            <div className="flex items-center gap-2">
              <span className="font-bold text-black text-[11px]">Resolution</span>
              {isFindMode ? (
                <Select value={findFields.resolution || undefined} allowClear className="!h-[28px] w-40 text-xs custom" placeholder="Search..." options={resolutionOptions.map((opt) => ({ value: opt.value, label: opt.label }))} onChange={(value) => setFindFields((p) => ({ ...p, resolution: value || "" }))} />
              ) : (
                <Select className="!h-[28px] w-40 text-xs custom" value={currentOrder.resolution} allowClear onChange={(value) => { if (value === "edit_resolution") { setStatusModalType("resolution"); setIsStatusModalOpen(true); return; } handleFieldUpdate("resolution", value ?? ""); }} options={[...resolutionOptions.map((opt) => ({ value: opt.value, label: opt.label })), { value: "edit_resolution", label: "✎ Edit Resolution..." }]} />
              )}
            </div>

            <div
              className="ml-auto text-[14px] font-bold"
              style={{ color: "#cc9900" }}
            >
              Date Entered:{" "}
              <span style={{ color: "#cc9900" }}>
                {currentOrder.dateCreated
                  ? dayjs(currentOrder.dateCreated).format("MM/DD/YYYY hh:mm A")
                  : "N/A"}
              </span>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
            <div className="flex gap-2 items-center">
              <span className="text-[11px] font-bold text-black">Customer</span>
              <div style={{ position: "relative" }}>
                <Input value={isFindMode ? findFields.customer : currentOrder.customer} onChange={(e) => isFindMode ? setFindFields((p) => ({ ...p, customer: e.target.value })) : handleFieldUpdate("customer", e.target.value)} onKeyDown={isFindMode ? (e) => { if (e.key === "Enter") { e.preventDefault(); handlePerformFind(); } } : undefined} className="Allinput !h-[28px] w-56 text-sm font-semibold text-gray-800" style={{ backgroundColor: "#ffff00" }} />
                {isFindMode && <SearchOutlined style={{ position: "absolute", right: 5, top: "50%", transform: "translateY(-50%)", color: "#888", fontSize: 11, pointerEvents: "none" }} />}
              </div>
            </div>

            <div className="flex gap-2 items-center">
              <span className="text-[11px] font-bold text-black">Quote ID</span>
              <div className="relative group" style={{ position: "relative" }}>
                <Input value={isFindMode ? findFields.quoteId : currentOrder.quoteId} onChange={(e) => isFindMode ? setFindFields((p) => ({ ...p, quoteId: e.target.value })) : handleFieldUpdate("quoteId", e.target.value)} onKeyDown={isFindMode ? (e) => { if (e.key === "Enter") { e.preventDefault(); handlePerformFind(); } } : undefined} className="Allinput !h-[28px] w-24 pr-7 text-sm font-semibold" style={{}} />
                {isFindMode && <SearchOutlined style={{ position: "absolute", right: 5, top: "50%", transform: "translateY(-50%)", color: "#888", fontSize: 11, pointerEvents: "none" }} />}
                {!isFindMode && (
                  <QuoteIdQuickNav
                    quoteId={currentOrder.quoteId}
                    targets={[
                      { path: "/otc", label: "OTC Snapshot" },
                      { path: "/order-tracking", label: "Order Tracking" },
                      { path: "/Quotes", label: "Quote", useQueryParam: true },
                    ]}
                  />
                )}
              </div>
            </div>

            <div className="flex gap-2 items-center">
              <span className="text-[11px] font-bold text-black">Cust PO #</span>
              <div style={{ position: "relative" }}>
                <Input value={isFindMode ? findFields.custPo : currentOrder.custPo} onChange={(e) => isFindMode ? setFindFields((p) => ({ ...p, custPo: e.target.value })) : handleFieldUpdate("custPo", e.target.value)} onKeyDown={isFindMode ? (e) => { if (e.key === "Enter") { e.preventDefault(); handlePerformFind(); } } : undefined} className="Allinput !h-[28px] w-36 text-sm font-semibold text-gray-800" />
                {isFindMode && <SearchOutlined style={{ position: "absolute", right: 5, top: "50%", transform: "translateY(-50%)", color: "#888", fontSize: 11, pointerEvents: "none" }} />}
              </div>
            </div>

            <div className="flex gap-2 items-center">
              <span className="text-[11px] font-bold text-black">SO Date</span>
              <DatePicker
                value={isFindMode ? (findFields.poDate ? dayjs(findFields.poDate) : null) : (currentOrder.poDate ? dayjs(currentOrder.poDate) : null)}
                format="MM/DD/YYYY"
                placeholder={isFindMode ? "Search..." : undefined}
                onChange={(date) =>
                  isFindMode
                    ? setFindFields((p) => ({ ...p, poDate: date?.format("YYYY-MM-DD") || "" }))
                    : handleFieldUpdate("poDate", date?.format("YYYY-MM-DD") || null)
                }
                className="!h-[28px] w-32 bg-[#ccffff] text-[10px]"
              />
            </div>

            <div className="flex gap-2 items-center">
              <span className="text-[11px] font-bold text-black">Sub-Status</span>
              {isFindMode ? (
                <Select value={findFields.subStatus || undefined} allowClear className="!h-[28px] w-36 text-xs" placeholder="Search..." options={subStatusOptions.map((opt) => ({ value: opt.value, label: opt.label }))} onChange={(value) => setFindFields((p) => ({ ...p, subStatus: value || "" }))} />
              ) : (
                <Select className="!h-[28px] w-36 text-xs" value={currentOrder.subStatus} allowClear onChange={(value) => { if (value === "edit_sub_status") { setStatusModalType("subStatus"); setIsStatusModalOpen(true); return; } handleFieldUpdate("subStatus", value ?? ""); }} options={[...subStatusOptions.map((opt) => ({ value: opt.value, label: opt.label })), { value: "edit_sub_status", label: "✎ Edit Sub Status..." }]} />
              )}
            </div>

            <div className="flex gap-2 items-center">
              <span className="text-[11px] font-bold text-black">Stock?</span>
              {isFindMode ? (
                <Select
                  className="!h-[28px] w-28 text-xs"
                  allowClear
                  placeholder="Search..."
                  value={findFields.stock || undefined}
                  onChange={(value) => setFindFields((p) => ({ ...p, stock: value || "" }))}
                  options={stockOptions.map((opt) => ({ value: opt.value, label: opt.label }))}
                />
              ) : (
                <Select
                  className="!h-[28px] w-28 text-xs"
                  value={currentOrder.stock}
                  allowClear
                  onChange={(value) => {
                    if (value === "edit_stock") {
                      setStatusModalType("stock");
                      setIsStatusModalOpen(true);
                      return;
                    }
                    handleFieldUpdate("stock", value ?? "");
                  }}
                  options={[
                    ...stockOptions.map((opt) => ({
                      value: opt.value,
                      label: opt.label,
                    })),
                    { value: "edit_stock", label: "✎ Edit Stock..." },
                  ]}
                />
              )}
            </div>

            <div className="ml-auto mt-auto">
              <Button className={btnFindRMA} onClick={handleFindRMA}>Find OPEN RMA</Button>
            </div>
          </div>
        </div>

        {/* ORDER BLOCKS */}
        <div className="pb-2">
          {currentOrder.orderBlocks &&
            currentOrder.orderBlocks.map((block, idx) => (
              <OpenOrderBlock
                key={idx}
                data={block}
                blockIndex={idx}
                onUpdate={handleBlockUpdate}
                manufacturers={manufacturers}
                onOpenManufacturerModal={() => setIsManufacturerModalOpen(true)}
                vendors={vendors}
                onOpenVendorModal={() => setIsVendorModalOpen(true)}
                shipTos={shipTos}
                onOpenShipToModal={() => setIsShipToModalOpen(true)}
                calTypes={calTypes}
                onOpenCalTypeModal={() => setIsCalTypeModalOpen(true)}
                isFindMode={isFindMode}
                findFields={findFields}
                onFindFieldChange={(field, value) => setFindFields((p) => ({ ...p, [field]: value }))}
                onPerformFind={handlePerformFind}
              />
            ))}
        </div>
      </Spin>

      {/* Manufacturer Management Modal */}
      {isManufacturerModalOpen && (
        <>
          {/* Blur overlay */}
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsManufacturerModalOpen(false);
              setEditingManufacturer(null);
              setNewManufacturerName("");
            }}
          />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-96 max-h-[500px] overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center bg-gray-50">
                <h3 className="text-[14px] font-semibold text-gray-700">
                  Manage Manufacturers
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => {
                    setIsManufacturerModalOpen(false);
                    setEditingManufacturer(null);
                    setNewManufacturerName("");
                  }}
                >
                  ✕
                </Button>
              </div>

              <div className="p-3 max-h-[380px] overflow-y-auto">
                {/* Manufacturer List */}
                <div className="space-y-2 mb-3">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Existing Manufacturers ({manufacturers.length})
                  </div>
                  {manufacturers.map((manufacturer) => (
                    <div
                      key={manufacturer.id}
                      className="flex items-center gap-1 group bg-gray-50 rounded p-1.5"
                    >
                      {editingManufacturer?.id === manufacturer.id ? (
                        <>
                          <Input
                            value={editingManufacturer.name}
                            onChange={(e) =>
                              setEditingManufacturer({
                                ...editingManufacturer,
                                name: e.target.value,
                              })
                            }
                            size="small"
                            className="h-7 text-[11px] flex-1"
                            autoFocus
                            onPressEnter={handleUpdateManufacturer}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleUpdateManufacturer}
                          >
                            <span className="text-[11px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center text-gray-500"
                            onClick={() => setEditingManufacturer(null)}
                          >
                            <span className="text-[11px]">✕</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[11px] flex-1">
                            {manufacturer.name}
                          </span>
                          <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() =>
                                setEditingManufacturer({
                                  id: manufacturer.id,
                                  name: manufacturer.name,
                                })
                              }
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() =>
                                handleDeleteManufacturer(
                                  manufacturer.id,
                                  manufacturer.name,
                                )
                              }
                            >
                              <RiDeleteBinLine className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {manufacturers.length === 0 && (
                    <div className="text-center text-gray-400 text-[11px] py-4">
                      No manufacturers added yet
                    </div>
                  )}
                </div>

                {/* Add New Manufacturer */}
                <div className="border-t border-gray-200 pt-3">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Add New Manufacturer
                  </div>
                  <div className="flex items-center gap-2">
                    <Input
                      placeholder="Enter manufacturer name"
                      value={newManufacturerName}
                      onChange={(e) => setNewManufacturerName(e.target.value)}
                      size="small"
                      className="h-7 text-[11px] flex-1"
                      onPressEnter={handleAddManufacturer}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-7 px-3 text-[11px] bg-[#004aad]"
                      onClick={handleAddManufacturer}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>

              <div className="p-2 border-t border-gray-200 flex justify-end bg-gray-50">
                <Button
                  size="small"
                  className="h-7 px-3 text-[11px]"
                  onClick={() => {
                    setIsManufacturerModalOpen(false);
                    setEditingManufacturer(null);
                    setNewManufacturerName("");
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      {isVendorModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsVendorModalOpen(false);
              setEditingVendor(null);
              setNewVendorName("");
            }}
          />

          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-96 max-h-[500px] overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center bg-gray-50">
                <h3 className="text-[14px] font-semibold text-gray-700">
                  Manage Vendors
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => {
                    setIsVendorModalOpen(false);
                    setEditingVendor(null);
                    setNewVendorName("");
                  }}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-[380px] overflow-y-auto">
                <div className="space-y-2 mb-3">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Existing Vendors ({vendors.length})
                  </div>
                  {vendors.map((vendor) => (
                    <div
                      key={vendor.id}
                      className="flex items-center gap-1 group bg-gray-50 rounded p-1.5"
                    >
                      {editingVendor?.id === vendor.id ? (
                        <>
                          <Input
                            value={editingVendor.name}
                            onChange={(e) =>
                              setEditingVendor({
                                ...editingVendor,
                                name: e.target.value,
                              })
                            }
                            size="small"
                            className="h-7 text-[11px] flex-1"
                            autoFocus
                            onPressEnter={handleUpdateVendor}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleUpdateVendor}
                          >
                            <CheckOutlined className="text-[12px]" />
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center text-gray-500"
                            onClick={() => setEditingVendor(null)}
                          >
                            <CloseOutlined className="text-[12px]" />
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[11px] flex-1">
                            {vendor.name}
                          </span>
                          <div className="flex gap-1 opacity-100">
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-blue-600 hover:text-blue-700"
                              onClick={() =>
                                setEditingVendor({
                                  id: vendor.id,
                                  name: vendor.name,
                                })
                              }
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-red-600 hover:text-red-700"
                              onClick={() =>
                                handleDeleteVendor(vendor.id, vendor.name)
                              }
                            >
                              <RiDeleteBinLine className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {!vendorsLoading && vendors.length === 0 && (
                    <div className="text-center text-gray-400 text-[11px] py-4">
                      No vendors added yet
                    </div>
                  )}
                </div>

                <div className="border-t border-gray-200 pt-3">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Add New Vendor
                  </div>
                  <div className="flex items-center gap-2">
                    <Input
                      placeholder="Enter vendor name"
                      value={newVendorName}
                      onChange={(e) => setNewVendorName(e.target.value)}
                      size="small"
                      className="h-7 text-[11px] flex-1"
                      onPressEnter={handleAddVendor}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-7 px-3 text-[11px] bg-[#004aad]"
                      onClick={handleAddVendor}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>

              <div className="p-2 border-t border-gray-200 flex justify-end bg-gray-50">
                <Button
                  size="small"
                  className="h-7 px-3 text-[11px]"
                  onClick={() => {
                    setIsVendorModalOpen(false);
                    setEditingVendor(null);
                    setNewVendorName("");
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      {isShipToModalOpen && (
        <>
          <div className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30" onClick={() => { setIsShipToModalOpen(false); setEditingShipTo(null); setNewShipToName(""); }} />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">Edit Ship To Options</h3>
                <Button type="text" size="small" className="h-5 w-5 p-0" onClick={() => { setIsShipToModalOpen(false); setEditingShipTo(null); setNewShipToName(""); }}>x</Button>
              </div>
              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {shipTos.map((s) => (
                    <div key={s.id} className="flex items-center gap-1 group">
                      {editingShipTo?.id === s.id ? (
                        <>
                          <Input value={editingShipTo.name} onChange={(e) => setEditingShipTo({ ...editingShipTo, name: e.target.value })} size="small" className="h-6 text-[10px] flex-1" autoFocus
                            onPressEnter={async () => { if (!editingShipTo.name.trim()) return; await updateShipTo(editingShipTo.id, editingShipTo.name.trim()); setEditingShipTo(null); refreshShipTos(); }} />
                          <Button type="primary" size="small" className="h-5 w-5 p-0 flex items-center justify-center bg-green-600" onClick={async () => { if (!editingShipTo.name.trim()) return; await updateShipTo(editingShipTo.id, editingShipTo.name.trim()); setEditingShipTo(null); refreshShipTos(); }}><span className="text-[10px]">✓</span></Button>
                          <Button type="text" size="small" className="h-5 w-5 p-0" onClick={() => setEditingShipTo(null)}><span className="text-[10px]">x</span></Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">{s.name}</span>
                          <Button type="text" size="small" className="h-4 w-4 p-0 text-gray-400 hover:text-blue-600" onClick={() => setEditingShipTo({ id: s.id, name: s.name })}><EditOutlined className="text-[12px]" /></Button>
                          <Button type="text" size="small" className="h-4 w-4 p-0 text-gray-400 hover:text-red-600" onClick={async () => { await deleteShipTo(s.id); refreshShipTos(); }}><RiDeleteBinLine className="text-[12px]" /></Button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">Add New</div>
                  <div className="flex items-center gap-1">
                    <Input placeholder="Enter ship to name" value={newShipToName} onChange={(e) => setNewShipToName(e.target.value)} size="small" className="h-6 text-[10px] flex-1"
                      onPressEnter={async () => { if (!newShipToName.trim()) return; await createShipTo(newShipToName.trim()); setNewShipToName(""); refreshShipTos(); }} />
                    <Button type="primary" size="small" className="h-6 px-2 text-[9px] bg-[#004aad]" onClick={async () => { if (!newShipToName.trim()) return; await createShipTo(newShipToName.trim()); setNewShipToName(""); refreshShipTos(); }}>Add</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isCalTypeModalOpen && (
        <>
          <div className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30" onClick={() => { setIsCalTypeModalOpen(false); setEditingCalType(null); setNewCalTypeName(""); }} />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">Edit Cal Type Options</h3>
                <Button type="text" size="small" className="h-5 w-5 p-0" onClick={() => { setIsCalTypeModalOpen(false); setEditingCalType(null); setNewCalTypeName(""); }}>x</Button>
              </div>
              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {calTypes.map((c) => (
                    <div key={c.id} className="flex items-center gap-1 group">
                      {editingCalType?.id === c.id ? (
                        <>
                          <Input value={editingCalType.name} onChange={(e) => setEditingCalType({ ...editingCalType, name: e.target.value })} size="small" className="h-6 text-[10px] flex-1" autoFocus
                            onPressEnter={async () => { if (!editingCalType.name.trim()) return; await updateCalType(editingCalType.id, editingCalType.name.trim()); setEditingCalType(null); refreshCalTypes(); }} />
                          <Button type="primary" size="small" className="h-5 w-5 p-0 flex items-center justify-center bg-green-600" onClick={async () => { if (!editingCalType.name.trim()) return; await updateCalType(editingCalType.id, editingCalType.name.trim()); setEditingCalType(null); refreshCalTypes(); }}><span className="text-[10px]">✓</span></Button>
                          <Button type="text" size="small" className="h-5 w-5 p-0" onClick={() => setEditingCalType(null)}><span className="text-[10px]">x</span></Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">{c.name}</span>
                          <Button type="text" size="small" className="h-4 w-4 p-0 text-gray-400 hover:text-blue-600" onClick={() => setEditingCalType({ id: c.id, name: c.name })}><EditOutlined className="text-[12px]" /></Button>
                          <Button type="text" size="small" className="h-4 w-4 p-0 text-gray-400 hover:text-red-600" onClick={async () => { await deleteCalType(c.id); refreshCalTypes(); }}><RiDeleteBinLine className="text-[12px]" /></Button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">Add New</div>
                  <div className="flex items-center gap-1">
                    <Input placeholder="Enter cal type name" value={newCalTypeName} onChange={(e) => setNewCalTypeName(e.target.value)} size="small" className="h-6 text-[10px] flex-1"
                      onPressEnter={async () => { if (!newCalTypeName.trim()) return; await createCalType(newCalTypeName.trim()); setNewCalTypeName(""); refreshCalTypes(); }} />
                    <Button type="primary" size="small" className="h-6 px-2 text-[9px] bg-[#004aad]" onClick={async () => { if (!newCalTypeName.trim()) return; await createCalType(newCalTypeName.trim()); setNewCalTypeName(""); refreshCalTypes(); }}>Add</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isStatusModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsStatusModalOpen(false);
              setEditingStatus({ index: -1, value: "" });
              setNewStatus("");
            }}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  {statusModalType === "stock"
                    ? "Edit Stock Options"
                    : statusModalType === "priority"
                      ? "Edit Priority Options"
                      : statusModalType === "subStatus"
                        ? "Edit Sub Status Options"
                        : statusModalType === "resolution"
                          ? "Edit Resolution Options"
                          : "Edit Status Options"}
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => {
                    setIsStatusModalOpen(false);
                    setEditingStatus({ index: -1, value: "" });
                    setNewStatus("");
                  }}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {getActiveModalOptions().map((option, index) => (
                    <div
                      key={option.id ?? index}
                      className="flex items-center gap-1 group"
                    >
                      {editingStatus.index === index ? (
                        <>
                          <Input
                            value={editingStatus.value}
                            onChange={(e) =>
                              setEditingStatus({
                                ...editingStatus,
                                value: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={handleSaveStatus}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleSaveStatus}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center text-gray-500"
                            onClick={() =>
                              setEditingStatus({ index: -1, value: "" })
                            }
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">
                            {option.label}
                          </span>
                          <div className="flex gap-1">
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() => handleEditStatus(index)}
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() => handleDeleteStatus(index)}
                            >
                              <RiDeleteBinLine className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New{" "}
                    {statusModalType === "stock"
                      ? "Stock"
                      : statusModalType === "priority"
                        ? "Priority"
                      : statusModalType === "subStatus"
                        ? "Sub Status"
                        : statusModalType === "resolution"
                          ? "Resolution"
                          : "Status"}
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter new status"
                      value={newStatus}
                      onChange={(e) => setNewStatus(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={handleAddStatus}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={handleAddStatus}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Send to Order Tracking Modal */}
      {isSendToOrderTrackingOpen && sendToOrderTrackingDraft && (
        <SendToOrderTrackingModal
          draft={sendToOrderTrackingDraft}
          setDraft={setSendToOrderTrackingDraft}
          saving={sendToOrderTrackingSaving}
          manufacturers={manufacturers}
          vendors={vendors}
          onCancel={() => setIsSendToOrderTrackingOpen(false)}
          onSave={handleSaveSendToOrderTracking}
        />
      )}
    </div>
  );
};

export default OpenOrder;
